import { P as it } from "./form-mask-input.92EW49hv.js";
function ot(A, R) {
  return R.forEach(function(M) {
    M && typeof M != "string" && !Array.isArray(M) && Object.keys(M).forEach(function(h) {
      if (h !== "default" && !(h in A)) {
        var e = Object.getOwnPropertyDescriptor(M, h);
        Object.defineProperty(A, h, e.get ? e : { enumerable: !0, get: function() {
          return M[h];
        } });
      }
    });
  }), Object.freeze(A);
}
function Ge(A, R) {
  return new Promise(function(M, h) {
    let e;
    return at(A).then(function(t) {
      try {
        return e = t, M(new Blob([R.slice(0, 2), e, R.slice(2)], { type: "image/jpeg" }));
      } catch (u) {
        return h(u);
      }
    }, h);
  });
}
const at = (A) => new Promise((R, M) => {
  const h = new FileReader();
  h.addEventListener("load", ({ target: { result: e } }) => {
    const t = new DataView(e);
    let u = 0;
    if (t.getUint16(u) !== 65496) return M("not a valid JPEG");
    for (u += 2; ; ) {
      const f = t.getUint16(u);
      if (f === 65498) break;
      const g = t.getUint16(u + 2);
      if (f === 65505 && t.getUint32(u + 4) === 1165519206) {
        const w = u + 10;
        let r;
        switch (t.getUint16(w)) {
          case 18761:
            r = !0;
            break;
          case 19789:
            r = !1;
            break;
          default:
            return M("TIFF header contains invalid endian");
        }
        if (t.getUint16(w + 2, r) !== 42) return M("TIFF header contains invalid version");
        const i = t.getUint32(w + 4, r), n = w + i + 2 + 12 * t.getUint16(w + i, r);
        for (let a = w + i + 2; a < n; a += 12)
          if (t.getUint16(a, r) == 274) {
            if (t.getUint16(a + 2, r) !== 3) return M("Orientation data type is invalid");
            if (t.getUint32(a + 4, r) !== 1) return M("Orientation data count is invalid");
            t.setUint16(a + 8, 1, r);
            break;
          }
        return R(e.slice(u, u + 2 + g));
      }
      u += 2 + g;
    }
    return R(new Blob());
  }), h.readAsArrayBuffer(A);
});
var xe = {}, ft = { get exports() {
  return xe;
}, set exports(A) {
  xe = A;
} };
(function(A) {
  var R, M, h = {};
  ft.exports = h, h.parse = function(e, t) {
    for (var u = h.bin.readUshort, f = h.bin.readUint, g = 0, w = {}, r = new Uint8Array(e), i = r.length - 4; f(r, i) != 101010256; ) i--;
    g = i, g += 4;
    var n = u(r, g += 4);
    u(r, g += 2);
    var a = f(r, g += 2), d = f(r, g += 4);
    g += 4, g = d;
    for (var F = 0; F < n; F++) {
      f(r, g), g += 4, g += 4, g += 4, f(r, g += 4), a = f(r, g += 4);
      var T = f(r, g += 4), b = u(r, g += 4), k = u(r, g + 2), P = u(r, g + 4);
      g += 6;
      var _ = f(r, g += 8);
      g += 4, g += b + k + P, h._readLocal(r, _, w, a, T, t);
    }
    return w;
  }, h._readLocal = function(e, t, u, f, g, w) {
    var r = h.bin.readUshort, i = h.bin.readUint;
    i(e, t), r(e, t += 4), r(e, t += 2);
    var n = r(e, t += 2);
    i(e, t += 2), i(e, t += 4), t += 4;
    var a = r(e, t += 8), d = r(e, t += 2);
    t += 2;
    var F = h.bin.readUTF8(e, t, a);
    if (t += a, t += d, w) u[F] = { size: g, csize: f };
    else {
      var T = new Uint8Array(e.buffer, t);
      if (n == 0) u[F] = new Uint8Array(T.buffer.slice(t, t + f));
      else {
        if (n != 8) throw "unknown compression method: " + n;
        var b = new Uint8Array(g);
        h.inflateRaw(T, b), u[F] = b;
      }
    }
  }, h.inflateRaw = function(e, t) {
    return h.F.inflate(e, t);
  }, h.inflate = function(e, t) {
    return e[0], e[1], h.inflateRaw(new Uint8Array(e.buffer, e.byteOffset + 2, e.length - 6), t);
  }, h.deflate = function(e, t) {
    t == null && (t = { level: 6 });
    var u = 0, f = new Uint8Array(50 + Math.floor(1.1 * e.length));
    f[u] = 120, f[u + 1] = 156, u += 2, u = h.F.deflateRaw(e, f, u, t.level);
    var g = h.adler(e, 0, e.length);
    return f[u + 0] = g >>> 24 & 255, f[u + 1] = g >>> 16 & 255, f[u + 2] = g >>> 8 & 255, f[u + 3] = g >>> 0 & 255, new Uint8Array(f.buffer, 0, u + 4);
  }, h.deflateRaw = function(e, t) {
    t == null && (t = { level: 6 });
    var u = new Uint8Array(50 + Math.floor(1.1 * e.length)), f = h.F.deflateRaw(e, u, f, t.level);
    return new Uint8Array(u.buffer, 0, f);
  }, h.encode = function(e, t) {
    t == null && (t = !1);
    var u = 0, f = h.bin.writeUint, g = h.bin.writeUshort, w = {};
    for (var r in e) {
      var i = !h._noNeed(r) && !t, n = e[r], a = h.crc.crc(n, 0, n.length);
      w[r] = { cpr: i, usize: n.length, crc: a, file: i ? h.deflateRaw(n) : n };
    }
    for (var r in w) u += w[r].file.length + 30 + 46 + 2 * h.bin.sizeUTF8(r);
    u += 22;
    var d = new Uint8Array(u), F = 0, T = [];
    for (var r in w) {
      var b = w[r];
      T.push(F), F = h._writeHeader(d, F, r, b, 0);
    }
    var k = 0, P = F;
    for (var r in w)
      b = w[r], T.push(F), F = h._writeHeader(d, F, r, b, 1, T[k++]);
    var _ = F - P;
    return f(d, F, 101010256), F += 4, g(d, F += 4, k), g(d, F += 2, k), f(d, F += 2, _), f(d, F += 4, P), F += 4, F += 2, d.buffer;
  }, h._noNeed = function(e) {
    var t = e.split(".").pop().toLowerCase();
    return "png,jpg,jpeg,zip".indexOf(t) != -1;
  }, h._writeHeader = function(e, t, u, f, g, w) {
    var r = h.bin.writeUint, i = h.bin.writeUshort, n = f.file;
    return r(e, t, g == 0 ? 67324752 : 33639248), t += 4, g == 1 && (t += 2), i(e, t, 20), i(e, t += 2, 0), i(e, t += 2, f.cpr ? 8 : 0), r(e, t += 2, 0), r(e, t += 4, f.crc), r(e, t += 4, n.length), r(e, t += 4, f.usize), i(e, t += 4, h.bin.sizeUTF8(u)), i(e, t += 2, 0), t += 2, g == 1 && (t += 2, t += 2, r(e, t += 6, w), t += 4), t += h.bin.writeUTF8(e, t, u), g == 0 && (e.set(n, t), t += n.length), t;
  }, h.crc = { table: function() {
    for (var e = new Uint32Array(256), t = 0; t < 256; t++) {
      for (var u = t, f = 0; f < 8; f++) 1 & u ? u = 3988292384 ^ u >>> 1 : u >>>= 1;
      e[t] = u;
    }
    return e;
  }(), update: function(e, t, u, f) {
    for (var g = 0; g < f; g++) e = h.crc.table[255 & (e ^ t[u + g])] ^ e >>> 8;
    return e;
  }, crc: function(e, t, u) {
    return 4294967295 ^ h.crc.update(4294967295, e, t, u);
  } }, h.adler = function(e, t, u) {
    for (var f = 1, g = 0, w = t, r = t + u; w < r; ) {
      for (var i = Math.min(w + 5552, r); w < i; ) g += f += e[w++];
      f %= 65521, g %= 65521;
    }
    return g << 16 | f;
  }, h.bin = { readUshort: function(e, t) {
    return e[t] | e[t + 1] << 8;
  }, writeUshort: function(e, t, u) {
    e[t] = 255 & u, e[t + 1] = u >> 8 & 255;
  }, readUint: function(e, t) {
    return 16777216 * e[t + 3] + (e[t + 2] << 16 | e[t + 1] << 8 | e[t]);
  }, writeUint: function(e, t, u) {
    e[t] = 255 & u, e[t + 1] = u >> 8 & 255, e[t + 2] = u >> 16 & 255, e[t + 3] = u >> 24 & 255;
  }, readASCII: function(e, t, u) {
    for (var f = "", g = 0; g < u; g++) f += String.fromCharCode(e[t + g]);
    return f;
  }, writeASCII: function(e, t, u) {
    for (var f = 0; f < u.length; f++) e[t + f] = u.charCodeAt(f);
  }, pad: function(e) {
    return e.length < 2 ? "0" + e : e;
  }, readUTF8: function(e, t, u) {
    for (var f, g = "", w = 0; w < u; w++) g += "%" + h.bin.pad(e[t + w].toString(16));
    try {
      f = decodeURIComponent(g);
    } catch {
      return h.bin.readASCII(e, t, u);
    }
    return f;
  }, writeUTF8: function(e, t, u) {
    for (var f = u.length, g = 0, w = 0; w < f; w++) {
      var r = u.charCodeAt(w);
      if ((4294967168 & r) == 0) e[t + g] = r, g++;
      else if ((4294965248 & r) == 0) e[t + g] = 192 | r >> 6, e[t + g + 1] = 128 | r >> 0 & 63, g += 2;
      else if ((4294901760 & r) == 0) e[t + g] = 224 | r >> 12, e[t + g + 1] = 128 | r >> 6 & 63, e[t + g + 2] = 128 | r >> 0 & 63, g += 3;
      else {
        if ((4292870144 & r) != 0) throw "e";
        e[t + g] = 240 | r >> 18, e[t + g + 1] = 128 | r >> 12 & 63, e[t + g + 2] = 128 | r >> 6 & 63, e[t + g + 3] = 128 | r >> 0 & 63, g += 4;
      }
    }
    return g;
  }, sizeUTF8: function(e) {
    for (var t = e.length, u = 0, f = 0; f < t; f++) {
      var g = e.charCodeAt(f);
      if ((4294967168 & g) == 0) u++;
      else if ((4294965248 & g) == 0) u += 2;
      else if ((4294901760 & g) == 0) u += 3;
      else {
        if ((4292870144 & g) != 0) throw "e";
        u += 4;
      }
    }
    return u;
  } }, h.F = {}, h.F.deflateRaw = function(e, t, u, f) {
    var g = [[0, 0, 0, 0, 0], [4, 4, 8, 4, 0], [4, 5, 16, 8, 0], [4, 6, 16, 16, 0], [4, 10, 16, 32, 0], [8, 16, 32, 32, 0], [8, 16, 128, 128, 0], [8, 32, 128, 256, 0], [32, 128, 258, 1024, 1], [32, 258, 258, 4096, 1]][f], w = h.F.U, r = h.F._goodIndex;
    h.F._hash;
    var i = h.F._putsE, n = 0, a = u << 3, d = 0, F = e.length;
    if (f == 0) {
      for (; n < F; )
        i(t, a, n + (U = Math.min(65535, F - n)) == F ? 1 : 0), a = h.F._copyExact(e, n, U, t, a + 8), n += U;
      return a >>> 3;
    }
    var T = w.lits, b = w.strt, k = w.prev, P = 0, _ = 0, O = 0, p = 0, x = 0, l = 0;
    for (F > 2 && (b[l = h.F._hash(e, 0)] = 0), n = 0; n < F; n++) {
      if (x = l, n + 1 < F - 2) {
        l = h.F._hash(e, n + 1);
        var s = n + 1 & 32767;
        k[s] = b[l], b[l] = s;
      }
      if (d <= n) {
        (P > 14e3 || _ > 26697) && F - n > 100 && (d < n && (T[P] = n - d, P += 2, d = n), a = h.F._writeBlock(n == F - 1 || d == F ? 1 : 0, T, P, p, e, O, n - O, t, a), P = _ = p = 0, O = n);
        var y = 0;
        n < F - 2 && (y = h.F._bestMatch(e, n, k, x, Math.min(g[2], F - n), g[3]));
        var U = y >>> 16, m = 65535 & y;
        if (y != 0) {
          m = 65535 & y;
          var I = r(U = y >>> 16, w.of0);
          w.lhst[257 + I]++;
          var v = r(m, w.df0);
          w.dhst[v]++, p += w.exb[I] + w.dxb[v], T[P] = U << 23 | n - d, T[P + 1] = m << 16 | I << 8 | v, P += 2, d = n + U;
        } else w.lhst[e[n]]++;
        _++;
      }
    }
    for (O == n && e.length != 0 || (d < n && (T[P] = n - d, P += 2, d = n), a = h.F._writeBlock(1, T, P, p, e, O, n - O, t, a), P = 0, _ = 0, P = _ = p = 0, O = n); (7 & a) != 0; ) a++;
    return a >>> 3;
  }, h.F._bestMatch = function(e, t, u, f, g, w) {
    var r = 32767 & t, i = u[r], n = r - i + 32768 & 32767;
    if (i == r || f != h.F._hash(e, t - n)) return 0;
    for (var a = 0, d = 0, F = Math.min(32767, t); n <= F && --w != 0 && i != r; ) {
      if (a == 0 || e[t + a] == e[t + a - n]) {
        var T = h.F._howLong(e, t, n);
        if (T > a) {
          if (d = n, (a = T) >= g) break;
          n + 2 < T && (T = n + 2);
          for (var b = 0, k = 0; k < T - 2; k++) {
            var P = t - n + k + 32768 & 32767, _ = P - u[P] + 32768 & 32767;
            _ > b && (b = _, i = P);
          }
        }
      }
      n += (r = i) - (i = u[r]) + 32768 & 32767;
    }
    return a << 16 | d;
  }, h.F._howLong = function(e, t, u) {
    if (e[t] != e[t - u] || e[t + 1] != e[t + 1 - u] || e[t + 2] != e[t + 2 - u]) return 0;
    var f = t, g = Math.min(e.length, t + 258);
    for (t += 3; t < g && e[t] == e[t - u]; ) t++;
    return t - f;
  }, h.F._hash = function(e, t) {
    return (e[t] << 8 | e[t + 1]) + (e[t + 2] << 4) & 65535;
  }, h.saved = 0, h.F._writeBlock = function(e, t, u, f, g, w, r, i, n) {
    var a, d, F, T, b, k, P, _, O, p = h.F.U, x = h.F._putsF, l = h.F._putsE;
    p.lhst[256]++, d = (a = h.F.getTrees())[0], F = a[1], T = a[2], b = a[3], k = a[4], P = a[5], _ = a[6], O = a[7];
    var s = 32 + ((n + 3 & 7) == 0 ? 0 : 8 - (n + 3 & 7)) + (r << 3), y = f + h.F.contSize(p.fltree, p.lhst) + h.F.contSize(p.fdtree, p.dhst), U = f + h.F.contSize(p.ltree, p.lhst) + h.F.contSize(p.dtree, p.dhst);
    U += 14 + 3 * P + h.F.contSize(p.itree, p.ihst) + (2 * p.ihst[16] + 3 * p.ihst[17] + 7 * p.ihst[18]);
    for (var m = 0; m < 286; m++) p.lhst[m] = 0;
    for (m = 0; m < 30; m++) p.dhst[m] = 0;
    for (m = 0; m < 19; m++) p.ihst[m] = 0;
    var I = s < y && s < U ? 0 : y < U ? 1 : 2;
    if (x(i, n, e), x(i, n + 1, I), n += 3, I == 0) {
      for (; (7 & n) != 0; ) n++;
      n = h.F._copyExact(g, w, r, i, n);
    } else {
      var v, C;
      if (I == 1 && (v = p.fltree, C = p.fdtree), I == 2) {
        h.F.makeCodes(p.ltree, d), h.F.revCodes(p.ltree, d), h.F.makeCodes(p.dtree, F), h.F.revCodes(p.dtree, F), h.F.makeCodes(p.itree, T), h.F.revCodes(p.itree, T), v = p.ltree, C = p.dtree, l(i, n, b - 257), l(i, n += 5, k - 1), l(i, n += 5, P - 4), n += 4;
        for (var c = 0; c < P; c++) l(i, n + 3 * c, p.itree[1 + (p.ordr[c] << 1)]);
        n += 3 * P, n = h.F._codeTiny(_, p.itree, i, n), n = h.F._codeTiny(O, p.itree, i, n);
      }
      for (var o = w, H = 0; H < u; H += 2) {
        for (var E = t[H], L = E >>> 23, Q = o + (8388607 & E); o < Q; ) n = h.F._writeLit(g[o++], v, i, n);
        if (L != 0) {
          var z = t[H + 1], B = z >> 16, N = z >> 8 & 255, S = 255 & z;
          l(i, n = h.F._writeLit(257 + N, v, i, n), L - p.of0[N]), n += p.exb[N], x(i, n = h.F._writeLit(S, C, i, n), B - p.df0[S]), n += p.dxb[S], o += L;
        }
      }
      n = h.F._writeLit(256, v, i, n);
    }
    return n;
  }, h.F._copyExact = function(e, t, u, f, g) {
    var w = g >>> 3;
    return f[w] = u, f[w + 1] = u >>> 8, f[w + 2] = 255 - f[w], f[w + 3] = 255 - f[w + 1], w += 4, f.set(new Uint8Array(e.buffer, t, u), w), g + (u + 4 << 3);
  }, h.F.getTrees = function() {
    for (var e = h.F.U, t = h.F._hufTree(e.lhst, e.ltree, 15), u = h.F._hufTree(e.dhst, e.dtree, 15), f = [], g = h.F._lenCodes(e.ltree, f), w = [], r = h.F._lenCodes(e.dtree, w), i = 0; i < f.length; i += 2) e.ihst[f[i]]++;
    for (i = 0; i < w.length; i += 2) e.ihst[w[i]]++;
    for (var n = h.F._hufTree(e.ihst, e.itree, 7), a = 19; a > 4 && e.itree[1 + (e.ordr[a - 1] << 1)] == 0; ) a--;
    return [t, u, n, g, r, a, f, w];
  }, h.F.getSecond = function(e) {
    for (var t = [], u = 0; u < e.length; u += 2) t.push(e[u + 1]);
    return t;
  }, h.F.nonZero = function(e) {
    for (var t = "", u = 0; u < e.length; u += 2) e[u + 1] != 0 && (t += (u >> 1) + ",");
    return t;
  }, h.F.contSize = function(e, t) {
    for (var u = 0, f = 0; f < t.length; f++) u += t[f] * e[1 + (f << 1)];
    return u;
  }, h.F._codeTiny = function(e, t, u, f) {
    for (var g = 0; g < e.length; g += 2) {
      var w = e[g], r = e[g + 1];
      f = h.F._writeLit(w, t, u, f);
      var i = w == 16 ? 2 : w == 17 ? 3 : 7;
      w > 15 && (h.F._putsE(u, f, r, i), f += i);
    }
    return f;
  }, h.F._lenCodes = function(e, t) {
    for (var u = e.length; u != 2 && e[u - 1] == 0; ) u -= 2;
    for (var f = 0; f < u; f += 2) {
      var g = e[f + 1], w = f + 3 < u ? e[f + 3] : -1, r = f + 5 < u ? e[f + 5] : -1, i = f == 0 ? -1 : e[f - 1];
      if (g == 0 && w == g && r == g) {
        for (var n = f + 5; n + 2 < u && e[n + 2] == g; ) n += 2;
        (a = Math.min(n + 1 - f >>> 1, 138)) < 11 ? t.push(17, a - 3) : t.push(18, a - 11), f += 2 * a - 2;
      } else if (g == i && w == g && r == g) {
        for (n = f + 5; n + 2 < u && e[n + 2] == g; ) n += 2;
        var a = Math.min(n + 1 - f >>> 1, 6);
        t.push(16, a - 3), f += 2 * a - 2;
      } else t.push(g, 0);
    }
    return u >>> 1;
  }, h.F._hufTree = function(e, t, u) {
    var f = [], g = e.length, w = t.length, r = 0;
    for (r = 0; r < w; r += 2) t[r] = 0, t[r + 1] = 0;
    for (r = 0; r < g; r++) e[r] != 0 && f.push({ lit: r, f: e[r] });
    var i = f.length, n = f.slice(0);
    if (i == 0) return 0;
    if (i == 1) {
      var a = f[0].lit;
      return n = a == 0 ? 1 : 0, t[1 + (a << 1)] = 1, t[1 + (n << 1)] = 1, 1;
    }
    f.sort(function(_, O) {
      return _.f - O.f;
    });
    var d = f[0], F = f[1], T = 0, b = 1, k = 2;
    for (f[0] = { lit: -1, f: d.f + F.f, l: d, r: F, d: 0 }; b != i - 1; ) d = T != b && (k == i || f[T].f < f[k].f) ? f[T++] : f[k++], F = T != b && (k == i || f[T].f < f[k].f) ? f[T++] : f[k++], f[b++] = { lit: -1, f: d.f + F.f, l: d, r: F };
    var P = h.F.setDepth(f[b - 1], 0);
    for (P > u && (h.F.restrictDepth(n, u, P), P = u), r = 0; r < i; r++) t[1 + (n[r].lit << 1)] = n[r].d;
    return P;
  }, h.F.setDepth = function(e, t) {
    return e.lit != -1 ? (e.d = t, t) : Math.max(h.F.setDepth(e.l, t + 1), h.F.setDepth(e.r, t + 1));
  }, h.F.restrictDepth = function(e, t, u) {
    var f = 0, g = 1 << u - t, w = 0;
    for (e.sort(function(i, n) {
      return n.d == i.d ? i.f - n.f : n.d - i.d;
    }), f = 0; f < e.length && e[f].d > t; f++) {
      var r = e[f].d;
      e[f].d = t, w += g - (1 << u - r);
    }
    for (w >>>= u - t; w > 0; )
      (r = e[f].d) < t ? (e[f].d++, w -= 1 << t - r - 1) : f++;
    for (; f >= 0; f--) e[f].d == t && w < 0 && (e[f].d--, w++);
    w != 0 && console.log("debt left");
  }, h.F._goodIndex = function(e, t) {
    var u = 0;
    return t[16 | u] <= e && (u |= 16), t[8 | u] <= e && (u |= 8), t[4 | u] <= e && (u |= 4), t[2 | u] <= e && (u |= 2), t[1 | u] <= e && (u |= 1), u;
  }, h.F._writeLit = function(e, t, u, f) {
    return h.F._putsF(u, f, t[e << 1]), f + t[1 + (e << 1)];
  }, h.F.inflate = function(e, t) {
    var u = Uint8Array;
    if (e[0] == 3 && e[1] == 0) return t || new u(0);
    var f = h.F, g = f._bitsF, w = f._bitsE, r = f._decodeTiny, i = f.makeCodes, n = f.codes2map, a = f._get17, d = f.U, F = t == null;
    F && (t = new u(e.length >>> 2 << 3));
    for (var T, b, k = 0, P = 0, _ = 0, O = 0, p = 0, x = 0, l = 0, s = 0, y = 0; k == 0; ) if (k = g(e, y, 1), P = g(e, y + 1, 2), y += 3, P != 0) {
      if (F && (t = h.F._check(t, s + (1 << 17))), P == 1 && (T = d.flmap, b = d.fdmap, x = 511, l = 31), P == 2) {
        _ = w(e, y, 5) + 257, O = w(e, y + 5, 5) + 1, p = w(e, y + 10, 4) + 4, y += 14;
        for (var U = 0; U < 38; U += 2) d.itree[U] = 0, d.itree[U + 1] = 0;
        var m = 1;
        for (U = 0; U < p; U++) {
          var I = w(e, y + 3 * U, 3);
          d.itree[1 + (d.ordr[U] << 1)] = I, I > m && (m = I);
        }
        y += 3 * p, i(d.itree, m), n(d.itree, m, d.imap), T = d.lmap, b = d.dmap, y = r(d.imap, (1 << m) - 1, _ + O, e, y, d.ttree);
        var v = f._copyOut(d.ttree, 0, _, d.ltree);
        x = (1 << v) - 1;
        var C = f._copyOut(d.ttree, _, O, d.dtree);
        l = (1 << C) - 1, i(d.ltree, v), n(d.ltree, v, T), i(d.dtree, C), n(d.dtree, C, b);
      }
      for (; ; ) {
        var c = T[a(e, y) & x];
        y += 15 & c;
        var o = c >>> 4;
        if (!(o >>> 8)) t[s++] = o;
        else {
          if (o == 256) break;
          var H = s + o - 254;
          if (o > 264) {
            var E = d.ldef[o - 257];
            H = s + (E >>> 3) + w(e, y, 7 & E), y += 7 & E;
          }
          var L = b[a(e, y) & l];
          y += 15 & L;
          var Q = L >>> 4, z = d.ddef[Q], B = (z >>> 4) + g(e, y, 15 & z);
          for (y += 15 & z, F && (t = h.F._check(t, s + (1 << 17))); s < H; ) t[s] = t[s++ - B], t[s] = t[s++ - B], t[s] = t[s++ - B], t[s] = t[s++ - B];
          s = H;
        }
      }
    } else {
      (7 & y) != 0 && (y += 8 - (7 & y));
      var N = 4 + (y >>> 3), S = e[N - 4] | e[N - 3] << 8;
      F && (t = h.F._check(t, s + S)), t.set(new u(e.buffer, e.byteOffset + N, S), s), y = N + S << 3, s += S;
    }
    return t.length == s ? t : t.slice(0, s);
  }, h.F._check = function(e, t) {
    var u = e.length;
    if (t <= u) return e;
    var f = new Uint8Array(Math.max(u << 1, t));
    return f.set(e, 0), f;
  }, h.F._decodeTiny = function(e, t, u, f, g, w) {
    for (var r = h.F._bitsE, i = h.F._get17, n = 0; n < u; ) {
      var a = e[i(f, g) & t];
      g += 15 & a;
      var d = a >>> 4;
      if (d <= 15) w[n] = d, n++;
      else {
        var F = 0, T = 0;
        d == 16 ? (T = 3 + r(f, g, 2), g += 2, F = w[n - 1]) : d == 17 ? (T = 3 + r(f, g, 3), g += 3) : d == 18 && (T = 11 + r(f, g, 7), g += 7);
        for (var b = n + T; n < b; ) w[n] = F, n++;
      }
    }
    return g;
  }, h.F._copyOut = function(e, t, u, f) {
    for (var g = 0, w = 0, r = f.length >>> 1; w < u; ) {
      var i = e[w + t];
      f[w << 1] = 0, f[1 + (w << 1)] = i, i > g && (g = i), w++;
    }
    for (; w < r; ) f[w << 1] = 0, f[1 + (w << 1)] = 0, w++;
    return g;
  }, h.F.makeCodes = function(e, t) {
    for (var u, f, g, w, r = h.F.U, i = e.length, n = r.bl_count, a = 0; a <= t; a++) n[a] = 0;
    for (a = 1; a < i; a += 2) n[e[a]]++;
    var d = r.next_code;
    for (u = 0, n[0] = 0, f = 1; f <= t; f++) u = u + n[f - 1] << 1, d[f] = u;
    for (g = 0; g < i; g += 2) (w = e[g + 1]) != 0 && (e[g] = d[w], d[w]++);
  }, h.F.codes2map = function(e, t, u) {
    for (var f = e.length, g = h.F.U.rev15, w = 0; w < f; w += 2) if (e[w + 1] != 0) for (var r = w >> 1, i = e[w + 1], n = r << 4 | i, a = t - i, d = e[w] << a, F = d + (1 << a); d != F; )
      u[g[d] >>> 15 - t] = n, d++;
  }, h.F.revCodes = function(e, t) {
    for (var u = h.F.U.rev15, f = 15 - t, g = 0; g < e.length; g += 2) {
      var w = e[g] << t - e[g + 1];
      e[g] = u[w] >>> f;
    }
  }, h.F._putsE = function(e, t, u) {
    u <<= 7 & t;
    var f = t >>> 3;
    e[f] |= u, e[f + 1] |= u >>> 8;
  }, h.F._putsF = function(e, t, u) {
    u <<= 7 & t;
    var f = t >>> 3;
    e[f] |= u, e[f + 1] |= u >>> 8, e[f + 2] |= u >>> 16;
  }, h.F._bitsE = function(e, t, u) {
    return (e[t >>> 3] | e[1 + (t >>> 3)] << 8) >>> (7 & t) & (1 << u) - 1;
  }, h.F._bitsF = function(e, t, u) {
    return (e[t >>> 3] | e[1 + (t >>> 3)] << 8 | e[2 + (t >>> 3)] << 16) >>> (7 & t) & (1 << u) - 1;
  }, h.F._get17 = function(e, t) {
    return (e[t >>> 3] | e[1 + (t >>> 3)] << 8 | e[2 + (t >>> 3)] << 16) >>> (7 & t);
  }, h.F._get25 = function(e, t) {
    return (e[t >>> 3] | e[1 + (t >>> 3)] << 8 | e[2 + (t >>> 3)] << 16 | e[3 + (t >>> 3)] << 24) >>> (7 & t);
  }, h.F.U = (R = Uint16Array, M = Uint32Array, { next_code: new R(16), bl_count: new R(16), ordr: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], of0: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], exb: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], ldef: new R(32), df0: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], dxb: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], ddef: new M(32), flmap: new R(512), fltree: [], fdmap: new R(32), fdtree: [], lmap: new R(32768), ltree: [], ttree: [], dmap: new R(32768), dtree: [], imap: new R(512), itree: [], rev15: new R(32768), lhst: new M(286), dhst: new M(30), ihst: new M(19), lits: new M(15e3), strt: new R(65536), prev: new R(32768) }), function() {
    for (var e = h.F.U, t = 0; t < 32768; t++) {
      var u = t;
      u = (4278255360 & (u = (4042322160 & (u = (3435973836 & (u = (2863311530 & u) >>> 1 | (1431655765 & u) << 1)) >>> 2 | (858993459 & u) << 2)) >>> 4 | (252645135 & u) << 4)) >>> 8 | (16711935 & u) << 8, e.rev15[t] = (u >>> 16 | u << 16) >>> 17;
    }
    function f(g, w, r) {
      for (; w-- != 0; ) g.push(0, r);
    }
    for (t = 0; t < 32; t++) e.ldef[t] = e.of0[t] << 3 | e.exb[t], e.ddef[t] = e.df0[t] << 4 | e.dxb[t];
    f(e.fltree, 144, 8), f(e.fltree, 112, 9), f(e.fltree, 24, 7), f(e.fltree, 8, 8), h.F.makeCodes(e.fltree, 9), h.F.codes2map(e.fltree, 9, e.flmap), h.F.revCodes(e.fltree, 9), f(e.fdtree, 32, 5), h.F.makeCodes(e.fdtree, 5), h.F.codes2map(e.fdtree, 5, e.fdmap), h.F.revCodes(e.fdtree, 5), f(e.itree, 19, 0), f(e.ltree, 286, 0), f(e.dtree, 30, 0), f(e.ttree, 320, 0);
  }();
})();
var st = ot({ __proto__: null, default: xe }, [xe]);
const he = function() {
  var A = { nextZero(r, i) {
    for (; r[i] != 0; ) i++;
    return i;
  }, readUshort: (r, i) => r[i] << 8 | r[i + 1], writeUshort(r, i, n) {
    r[i] = n >> 8 & 255, r[i + 1] = 255 & n;
  }, readUint: (r, i) => 16777216 * r[i] + (r[i + 1] << 16 | r[i + 2] << 8 | r[i + 3]), writeUint(r, i, n) {
    r[i] = n >> 24 & 255, r[i + 1] = n >> 16 & 255, r[i + 2] = n >> 8 & 255, r[i + 3] = 255 & n;
  }, readASCII(r, i, n) {
    let a = "";
    for (let d = 0; d < n; d++) a += String.fromCharCode(r[i + d]);
    return a;
  }, writeASCII(r, i, n) {
    for (let a = 0; a < n.length; a++) r[i + a] = n.charCodeAt(a);
  }, readBytes(r, i, n) {
    const a = [];
    for (let d = 0; d < n; d++) a.push(r[i + d]);
    return a;
  }, pad: (r) => r.length < 2 ? `0${r}` : r, readUTF8(r, i, n) {
    let a, d = "";
    for (let F = 0; F < n; F++) d += `%${A.pad(r[i + F].toString(16))}`;
    try {
      a = decodeURIComponent(d);
    } catch {
      return A.readASCII(r, i, n);
    }
    return a;
  } };
  function R(r, i, n, a) {
    const d = i * n, F = t(a), T = Math.ceil(i * F / 8), b = new Uint8Array(4 * d), k = new Uint32Array(b.buffer), { ctype: P } = a, { depth: _ } = a, O = A.readUshort;
    if (P == 6) {
      const E = d << 2;
      if (_ == 8) for (var p = 0; p < E; p += 4) b[p] = r[p], b[p + 1] = r[p + 1], b[p + 2] = r[p + 2], b[p + 3] = r[p + 3];
      if (_ == 16) for (p = 0; p < E; p++) b[p] = r[p << 1];
    } else if (P == 2) {
      const E = a.tabs.tRNS;
      if (E == null) {
        if (_ == 8) for (p = 0; p < d; p++) {
          var x = 3 * p;
          k[p] = 255 << 24 | r[x + 2] << 16 | r[x + 1] << 8 | r[x];
        }
        if (_ == 16) for (p = 0; p < d; p++)
          x = 6 * p, k[p] = 255 << 24 | r[x + 4] << 16 | r[x + 2] << 8 | r[x];
      } else {
        var l = E[0];
        const L = E[1], Q = E[2];
        if (_ == 8) for (p = 0; p < d; p++) {
          var s = p << 2;
          x = 3 * p, k[p] = 255 << 24 | r[x + 2] << 16 | r[x + 1] << 8 | r[x], r[x] == l && r[x + 1] == L && r[x + 2] == Q && (b[s + 3] = 0);
        }
        if (_ == 16) for (p = 0; p < d; p++)
          s = p << 2, x = 6 * p, k[p] = 255 << 24 | r[x + 4] << 16 | r[x + 2] << 8 | r[x], O(r, x) == l && O(r, x + 2) == L && O(r, x + 4) == Q && (b[s + 3] = 0);
      }
    } else if (P == 3) {
      const E = a.tabs.PLTE, L = a.tabs.tRNS, Q = L ? L.length : 0;
      if (_ == 1) for (var y = 0; y < n; y++) {
        var U = y * T, m = y * i;
        for (p = 0; p < i; p++) {
          s = m + p << 2;
          var I = 3 * (v = r[U + (p >> 3)] >> 7 - ((7 & p) << 0) & 1);
          b[s] = E[I], b[s + 1] = E[I + 1], b[s + 2] = E[I + 2], b[s + 3] = v < Q ? L[v] : 255;
        }
      }
      if (_ == 2) for (y = 0; y < n; y++) for (U = y * T, m = y * i, p = 0; p < i; p++)
        s = m + p << 2, I = 3 * (v = r[U + (p >> 2)] >> 6 - ((3 & p) << 1) & 3), b[s] = E[I], b[s + 1] = E[I + 1], b[s + 2] = E[I + 2], b[s + 3] = v < Q ? L[v] : 255;
      if (_ == 4) for (y = 0; y < n; y++) for (U = y * T, m = y * i, p = 0; p < i; p++)
        s = m + p << 2, I = 3 * (v = r[U + (p >> 1)] >> 4 - ((1 & p) << 2) & 15), b[s] = E[I], b[s + 1] = E[I + 1], b[s + 2] = E[I + 2], b[s + 3] = v < Q ? L[v] : 255;
      if (_ == 8) for (p = 0; p < d; p++) {
        var v;
        s = p << 2, I = 3 * (v = r[p]), b[s] = E[I], b[s + 1] = E[I + 1], b[s + 2] = E[I + 2], b[s + 3] = v < Q ? L[v] : 255;
      }
    } else if (P == 4) {
      if (_ == 8) for (p = 0; p < d; p++) {
        s = p << 2;
        var C = r[c = p << 1];
        b[s] = C, b[s + 1] = C, b[s + 2] = C, b[s + 3] = r[c + 1];
      }
      if (_ == 16) for (p = 0; p < d; p++) {
        var c;
        s = p << 2, C = r[c = p << 2], b[s] = C, b[s + 1] = C, b[s + 2] = C, b[s + 3] = r[c + 2];
      }
    } else if (P == 0) for (l = a.tabs.tRNS ? a.tabs.tRNS : -1, y = 0; y < n; y++) {
      const E = y * T, L = y * i;
      if (_ == 1) for (var o = 0; o < i; o++) {
        var H = (C = 255 * (r[E + (o >>> 3)] >>> 7 - (7 & o) & 1)) == 255 * l ? 0 : 255;
        k[L + o] = H << 24 | C << 16 | C << 8 | C;
      }
      else if (_ == 2) for (o = 0; o < i; o++)
        H = (C = 85 * (r[E + (o >>> 2)] >>> 6 - ((3 & o) << 1) & 3)) == 85 * l ? 0 : 255, k[L + o] = H << 24 | C << 16 | C << 8 | C;
      else if (_ == 4) for (o = 0; o < i; o++)
        H = (C = 17 * (r[E + (o >>> 1)] >>> 4 - ((1 & o) << 2) & 15)) == 17 * l ? 0 : 255, k[L + o] = H << 24 | C << 16 | C << 8 | C;
      else if (_ == 8) for (o = 0; o < i; o++)
        H = (C = r[E + o]) == l ? 0 : 255, k[L + o] = H << 24 | C << 16 | C << 8 | C;
      else if (_ == 16) for (o = 0; o < i; o++)
        C = r[E + (o << 1)], H = O(r, E + (o << 1)) == l ? 0 : 255, k[L + o] = H << 24 | C << 16 | C << 8 | C;
    }
    return b;
  }
  function M(r, i, n, a) {
    const d = t(r), F = Math.ceil(n * d / 8), T = new Uint8Array((F + 1 + r.interlace) * a);
    return i = r.tabs.CgBI ? e(i, T) : h(i, T), r.interlace == 0 ? i = u(i, r, 0, n, a) : r.interlace == 1 && (i = function(k, P) {
      const _ = P.width, O = P.height, p = t(P), x = p >> 3, l = Math.ceil(_ * p / 8), s = new Uint8Array(O * l);
      let y = 0;
      const U = [0, 0, 4, 0, 2, 0, 1], m = [0, 4, 0, 2, 0, 1, 0], I = [8, 8, 8, 4, 4, 2, 2], v = [8, 8, 4, 4, 2, 2, 1];
      let C = 0;
      for (; C < 7; ) {
        const o = I[C], H = v[C];
        let E = 0, L = 0, Q = U[C];
        for (; Q < O; ) Q += o, L++;
        let z = m[C];
        for (; z < _; ) z += H, E++;
        const B = Math.ceil(E * p / 8);
        u(k, P, y, E, L);
        let N = 0, S = U[C];
        for (; S < O; ) {
          let D = m[C], K = y + N * B << 3;
          for (; D < _; ) {
            var c;
            if (p == 1 && (c = (c = k[K >> 3]) >> 7 - (7 & K) & 1, s[S * l + (D >> 3)] |= c << 7 - ((7 & D) << 0)), p == 2 && (c = (c = k[K >> 3]) >> 6 - (7 & K) & 3, s[S * l + (D >> 2)] |= c << 6 - ((3 & D) << 1)), p == 4 && (c = (c = k[K >> 3]) >> 4 - (7 & K) & 15, s[S * l + (D >> 1)] |= c << 4 - ((1 & D) << 2)), p >= 8) {
              const $ = S * l + D * x;
              for (let W = 0; W < x; W++) s[$ + W] = k[(K >> 3) + W];
            }
            K += p, D += H;
          }
          N++, S += o;
        }
        E * L != 0 && (y += L * (1 + B)), C += 1;
      }
      return s;
    }(i, r)), i;
  }
  function h(r, i) {
    return e(new Uint8Array(r.buffer, 2, r.length - 6), i);
  }
  var e = function() {
    const r = { H: {} };
    return r.H.N = function(i, n) {
      const a = Uint8Array;
      let d, F, T = 0, b = 0, k = 0, P = 0, _ = 0, O = 0, p = 0, x = 0, l = 0;
      if (i[0] == 3 && i[1] == 0) return n || new a(0);
      const s = r.H, y = s.b, U = s.e, m = s.R, I = s.n, v = s.A, C = s.Z, c = s.m, o = n == null;
      for (o && (n = new a(i.length >>> 2 << 5)); T == 0; ) if (T = y(i, l, 1), b = y(i, l + 1, 2), l += 3, b != 0) {
        if (o && (n = r.H.W(n, x + (1 << 17))), b == 1 && (d = c.J, F = c.h, O = 511, p = 31), b == 2) {
          k = U(i, l, 5) + 257, P = U(i, l + 5, 5) + 1, _ = U(i, l + 10, 4) + 4, l += 14;
          let E = 1;
          for (var H = 0; H < 38; H += 2) c.Q[H] = 0, c.Q[H + 1] = 0;
          for (H = 0; H < _; H++) {
            const z = U(i, l + 3 * H, 3);
            c.Q[1 + (c.X[H] << 1)] = z, z > E && (E = z);
          }
          l += 3 * _, I(c.Q, E), v(c.Q, E, c.u), d = c.w, F = c.d, l = m(c.u, (1 << E) - 1, k + P, i, l, c.v);
          const L = s.V(c.v, 0, k, c.C);
          O = (1 << L) - 1;
          const Q = s.V(c.v, k, P, c.D);
          p = (1 << Q) - 1, I(c.C, L), v(c.C, L, d), I(c.D, Q), v(c.D, Q, F);
        }
        for (; ; ) {
          const E = d[C(i, l) & O];
          l += 15 & E;
          const L = E >>> 4;
          if (!(L >>> 8)) n[x++] = L;
          else {
            if (L == 256) break;
            {
              let Q = x + L - 254;
              if (L > 264) {
                const D = c.q[L - 257];
                Q = x + (D >>> 3) + U(i, l, 7 & D), l += 7 & D;
              }
              const z = F[C(i, l) & p];
              l += 15 & z;
              const B = z >>> 4, N = c.c[B], S = (N >>> 4) + y(i, l, 15 & N);
              for (l += 15 & N; x < Q; ) n[x] = n[x++ - S], n[x] = n[x++ - S], n[x] = n[x++ - S], n[x] = n[x++ - S];
              x = Q;
            }
          }
        }
      } else {
        (7 & l) != 0 && (l += 8 - (7 & l));
        const E = 4 + (l >>> 3), L = i[E - 4] | i[E - 3] << 8;
        o && (n = r.H.W(n, x + L)), n.set(new a(i.buffer, i.byteOffset + E, L), x), l = E + L << 3, x += L;
      }
      return n.length == x ? n : n.slice(0, x);
    }, r.H.W = function(i, n) {
      const a = i.length;
      if (n <= a) return i;
      const d = new Uint8Array(a << 1);
      return d.set(i, 0), d;
    }, r.H.R = function(i, n, a, d, F, T) {
      const b = r.H.e, k = r.H.Z;
      let P = 0;
      for (; P < a; ) {
        const _ = i[k(d, F) & n];
        F += 15 & _;
        const O = _ >>> 4;
        if (O <= 15) T[P] = O, P++;
        else {
          let p = 0, x = 0;
          O == 16 ? (x = 3 + b(d, F, 2), F += 2, p = T[P - 1]) : O == 17 ? (x = 3 + b(d, F, 3), F += 3) : O == 18 && (x = 11 + b(d, F, 7), F += 7);
          const l = P + x;
          for (; P < l; ) T[P] = p, P++;
        }
      }
      return F;
    }, r.H.V = function(i, n, a, d) {
      let F = 0, T = 0;
      const b = d.length >>> 1;
      for (; T < a; ) {
        const k = i[T + n];
        d[T << 1] = 0, d[1 + (T << 1)] = k, k > F && (F = k), T++;
      }
      for (; T < b; ) d[T << 1] = 0, d[1 + (T << 1)] = 0, T++;
      return F;
    }, r.H.n = function(i, n) {
      const a = r.H.m, d = i.length;
      let F, T, b, k;
      const P = a.j;
      for (var _ = 0; _ <= n; _++) P[_] = 0;
      for (_ = 1; _ < d; _ += 2) P[i[_]]++;
      const O = a.K;
      for (F = 0, P[0] = 0, T = 1; T <= n; T++) F = F + P[T - 1] << 1, O[T] = F;
      for (b = 0; b < d; b += 2) k = i[b + 1], k != 0 && (i[b] = O[k], O[k]++);
    }, r.H.A = function(i, n, a) {
      const d = i.length, F = r.H.m.r;
      for (let T = 0; T < d; T += 2) if (i[T + 1] != 0) {
        const b = T >> 1, k = i[T + 1], P = b << 4 | k, _ = n - k;
        let O = i[T] << _;
        const p = O + (1 << _);
        for (; O != p; )
          a[F[O] >>> 15 - n] = P, O++;
      }
    }, r.H.l = function(i, n) {
      const a = r.H.m.r, d = 15 - n;
      for (let F = 0; F < i.length; F += 2) {
        const T = i[F] << n - i[F + 1];
        i[F] = a[T] >>> d;
      }
    }, r.H.M = function(i, n, a) {
      a <<= 7 & n;
      const d = n >>> 3;
      i[d] |= a, i[d + 1] |= a >>> 8;
    }, r.H.I = function(i, n, a) {
      a <<= 7 & n;
      const d = n >>> 3;
      i[d] |= a, i[d + 1] |= a >>> 8, i[d + 2] |= a >>> 16;
    }, r.H.e = function(i, n, a) {
      return (i[n >>> 3] | i[1 + (n >>> 3)] << 8) >>> (7 & n) & (1 << a) - 1;
    }, r.H.b = function(i, n, a) {
      return (i[n >>> 3] | i[1 + (n >>> 3)] << 8 | i[2 + (n >>> 3)] << 16) >>> (7 & n) & (1 << a) - 1;
    }, r.H.Z = function(i, n) {
      return (i[n >>> 3] | i[1 + (n >>> 3)] << 8 | i[2 + (n >>> 3)] << 16) >>> (7 & n);
    }, r.H.i = function(i, n) {
      return (i[n >>> 3] | i[1 + (n >>> 3)] << 8 | i[2 + (n >>> 3)] << 16 | i[3 + (n >>> 3)] << 24) >>> (7 & n);
    }, r.H.m = function() {
      const i = Uint16Array, n = Uint32Array;
      return { K: new i(16), j: new i(16), X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], S: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], T: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], q: new i(32), p: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], z: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], c: new n(32), J: new i(512), _: [], h: new i(32), $: [], w: new i(32768), C: [], v: [], d: new i(32768), D: [], u: new i(512), Q: [], r: new i(32768), s: new n(286), Y: new n(30), a: new n(19), t: new n(15e3), k: new i(65536), g: new i(32768) };
    }(), function() {
      const i = r.H.m;
      for (var n = 0; n < 32768; n++) {
        let d = n;
        d = (2863311530 & d) >>> 1 | (1431655765 & d) << 1, d = (3435973836 & d) >>> 2 | (858993459 & d) << 2, d = (4042322160 & d) >>> 4 | (252645135 & d) << 4, d = (4278255360 & d) >>> 8 | (16711935 & d) << 8, i.r[n] = (d >>> 16 | d << 16) >>> 17;
      }
      function a(d, F, T) {
        for (; F-- != 0; ) d.push(0, T);
      }
      for (n = 0; n < 32; n++) i.q[n] = i.S[n] << 3 | i.T[n], i.c[n] = i.p[n] << 4 | i.z[n];
      a(i._, 144, 8), a(i._, 112, 9), a(i._, 24, 7), a(i._, 8, 8), r.H.n(i._, 9), r.H.A(i._, 9, i.J), r.H.l(i._, 9), a(i.$, 32, 5), r.H.n(i.$, 5), r.H.A(i.$, 5, i.h), r.H.l(i.$, 5), a(i.Q, 19, 0), a(i.C, 286, 0), a(i.D, 30, 0), a(i.v, 320, 0);
    }(), r.H.N;
  }();
  function t(r) {
    return [1, null, 3, 1, 2, null, 4][r.ctype] * r.depth;
  }
  function u(r, i, n, a, d) {
    let F = t(i);
    const T = Math.ceil(a * F / 8);
    let b, k;
    F = Math.ceil(F / 8);
    let P = r[n], _ = 0;
    if (P > 1 && (r[n] = [0, 0, 1][P - 2]), P == 3) for (_ = F; _ < T; _++) r[_ + 1] = r[_ + 1] + (r[_ + 1 - F] >>> 1) & 255;
    for (let O = 0; O < d; O++) if (b = n + O * T, k = b + O + 1, P = r[k - 1], _ = 0, P == 0) for (; _ < T; _++) r[b + _] = r[k + _];
    else if (P == 1) {
      for (; _ < F; _++) r[b + _] = r[k + _];
      for (; _ < T; _++) r[b + _] = r[k + _] + r[b + _ - F];
    } else if (P == 2) for (; _ < T; _++) r[b + _] = r[k + _] + r[b + _ - T];
    else if (P == 3) {
      for (; _ < F; _++) r[b + _] = r[k + _] + (r[b + _ - T] >>> 1);
      for (; _ < T; _++) r[b + _] = r[k + _] + (r[b + _ - T] + r[b + _ - F] >>> 1);
    } else {
      for (; _ < F; _++) r[b + _] = r[k + _] + f(0, r[b + _ - T], 0);
      for (; _ < T; _++) r[b + _] = r[k + _] + f(r[b + _ - F], r[b + _ - T], r[b + _ - F - T]);
    }
    return r;
  }
  function f(r, i, n) {
    const a = r + i - n, d = a - r, F = a - i, T = a - n;
    return d * d <= F * F && d * d <= T * T ? r : F * F <= T * T ? i : n;
  }
  function g(r, i, n) {
    n.width = A.readUint(r, i), i += 4, n.height = A.readUint(r, i), i += 4, n.depth = r[i], i++, n.ctype = r[i], i++, n.compress = r[i], i++, n.filter = r[i], i++, n.interlace = r[i], i++;
  }
  function w(r, i, n, a, d, F, T, b, k) {
    const P = Math.min(i, d), _ = Math.min(n, F);
    let O = 0, p = 0;
    for (let C = 0; C < _; C++) for (let c = 0; c < P; c++) if (T >= 0 && b >= 0 ? (O = C * i + c << 2, p = (b + C) * d + T + c << 2) : (O = (-b + C) * i - T + c << 2, p = C * d + c << 2), k == 0) a[p] = r[O], a[p + 1] = r[O + 1], a[p + 2] = r[O + 2], a[p + 3] = r[O + 3];
    else if (k == 1) {
      var x = r[O + 3] * 0.00392156862745098, l = r[O] * x, s = r[O + 1] * x, y = r[O + 2] * x, U = a[p + 3] * (1 / 255), m = a[p] * U, I = a[p + 1] * U, v = a[p + 2] * U;
      const o = 1 - x, H = x + U * o, E = H == 0 ? 0 : 1 / H;
      a[p + 3] = 255 * H, a[p + 0] = (l + m * o) * E, a[p + 1] = (s + I * o) * E, a[p + 2] = (y + v * o) * E;
    } else if (k == 2)
      x = r[O + 3], l = r[O], s = r[O + 1], y = r[O + 2], U = a[p + 3], m = a[p], I = a[p + 1], v = a[p + 2], x == U && l == m && s == I && y == v ? (a[p] = 0, a[p + 1] = 0, a[p + 2] = 0, a[p + 3] = 0) : (a[p] = l, a[p + 1] = s, a[p + 2] = y, a[p + 3] = x);
    else if (k == 3) {
      if (x = r[O + 3], l = r[O], s = r[O + 1], y = r[O + 2], U = a[p + 3], m = a[p], I = a[p + 1], v = a[p + 2], x == U && l == m && s == I && y == v) continue;
      if (x < 220 && U > 20) return !1;
    }
    return !0;
  }
  return { decode: function(i) {
    const n = new Uint8Array(i);
    let a = 8;
    const d = A, F = d.readUshort, T = d.readUint, b = { tabs: {}, frames: [] }, k = new Uint8Array(n.length);
    let P, _ = 0, O = 0;
    const p = [137, 80, 78, 71, 13, 10, 26, 10];
    for (var x = 0; x < 8; x++) if (n[x] != p[x]) throw "The input is not a PNG file!";
    for (; a < n.length; ) {
      const C = d.readUint(n, a);
      a += 4;
      const c = d.readASCII(n, a, 4);
      if (a += 4, c == "IHDR") g(n, a, b);
      else if (c == "iCCP") {
        for (var l = a; n[l] != 0; ) l++;
        d.readASCII(n, a, l - a), n[l + 1];
        const o = n.slice(l + 2, a + C);
        let H = null;
        try {
          H = h(o);
        } catch {
          H = e(o);
        }
        b.tabs[c] = H;
      } else if (c == "CgBI") b.tabs[c] = n.slice(a, a + 4);
      else if (c == "IDAT") {
        for (x = 0; x < C; x++) k[_ + x] = n[a + x];
        _ += C;
      } else if (c == "acTL") b.tabs[c] = { num_frames: T(n, a), num_plays: T(n, a + 4) }, P = new Uint8Array(n.length);
      else if (c == "fcTL") {
        O != 0 && ((v = b.frames[b.frames.length - 1]).data = M(b, P.slice(0, O), v.rect.width, v.rect.height), O = 0);
        const o = { x: T(n, a + 12), y: T(n, a + 16), width: T(n, a + 4), height: T(n, a + 8) };
        let H = F(n, a + 22);
        H = F(n, a + 20) / (H == 0 ? 100 : H);
        const E = { rect: o, delay: Math.round(1e3 * H), dispose: n[a + 24], blend: n[a + 25] };
        b.frames.push(E);
      } else if (c == "fdAT") {
        for (x = 0; x < C - 4; x++) P[O + x] = n[a + x + 4];
        O += C - 4;
      } else if (c == "pHYs") b.tabs[c] = [d.readUint(n, a), d.readUint(n, a + 4), n[a + 8]];
      else if (c == "cHRM")
        for (b.tabs[c] = [], x = 0; x < 8; x++) b.tabs[c].push(d.readUint(n, a + 4 * x));
      else if (c == "tEXt" || c == "zTXt") {
        b.tabs[c] == null && (b.tabs[c] = {});
        var s = d.nextZero(n, a), y = d.readASCII(n, a, s - a), U = a + C - s - 1;
        if (c == "tEXt") I = d.readASCII(n, s + 1, U);
        else {
          var m = h(n.slice(s + 2, s + 2 + U));
          I = d.readUTF8(m, 0, m.length);
        }
        b.tabs[c][y] = I;
      } else if (c == "iTXt") {
        b.tabs[c] == null && (b.tabs[c] = {}), s = 0, l = a, s = d.nextZero(n, l), y = d.readASCII(n, l, s - l);
        const o = n[l = s + 1];
        var I;
        n[l + 1], l += 2, s = d.nextZero(n, l), d.readASCII(n, l, s - l), l = s + 1, s = d.nextZero(n, l), d.readUTF8(n, l, s - l), U = C - ((l = s + 1) - a), o == 0 ? I = d.readUTF8(n, l, U) : (m = h(n.slice(l, l + U)), I = d.readUTF8(m, 0, m.length)), b.tabs[c][y] = I;
      } else if (c == "PLTE") b.tabs[c] = d.readBytes(n, a, C);
      else if (c == "hIST") {
        const o = b.tabs.PLTE.length / 3;
        for (b.tabs[c] = [], x = 0; x < o; x++) b.tabs[c].push(F(n, a + 2 * x));
      } else if (c == "tRNS") b.ctype == 3 ? b.tabs[c] = d.readBytes(n, a, C) : b.ctype == 0 ? b.tabs[c] = F(n, a) : b.ctype == 2 && (b.tabs[c] = [F(n, a), F(n, a + 2), F(n, a + 4)]);
      else if (c == "gAMA") b.tabs[c] = d.readUint(n, a) / 1e5;
      else if (c == "sRGB") b.tabs[c] = n[a];
      else if (c == "bKGD") b.ctype == 0 || b.ctype == 4 ? b.tabs[c] = [F(n, a)] : b.ctype == 2 || b.ctype == 6 ? b.tabs[c] = [F(n, a), F(n, a + 2), F(n, a + 4)] : b.ctype == 3 && (b.tabs[c] = n[a]);
      else if (c == "IEND") break;
      a += C, d.readUint(n, a), a += 4;
    }
    var v;
    return O != 0 && ((v = b.frames[b.frames.length - 1]).data = M(b, P.slice(0, O), v.rect.width, v.rect.height)), b.data = M(b, k, b.width, b.height), delete b.compress, delete b.interlace, delete b.filter, b;
  }, toRGBA8: function(i) {
    const n = i.width, a = i.height;
    if (i.tabs.acTL == null) return [R(i.data, n, a, i).buffer];
    const d = [];
    i.frames[0].data == null && (i.frames[0].data = i.data);
    const F = n * a * 4, T = new Uint8Array(F), b = new Uint8Array(F), k = new Uint8Array(F);
    for (let _ = 0; _ < i.frames.length; _++) {
      const O = i.frames[_], p = O.rect.x, x = O.rect.y, l = O.rect.width, s = O.rect.height, y = R(O.data, l, s, i);
      if (_ != 0) for (var P = 0; P < F; P++) k[P] = T[P];
      if (O.blend == 0 ? w(y, l, s, T, n, a, p, x, 0) : O.blend == 1 && w(y, l, s, T, n, a, p, x, 1), d.push(T.buffer.slice(0)), O.dispose != 0) {
        if (O.dispose == 1) w(b, l, s, T, n, a, p, x, 0);
        else if (O.dispose == 2) for (P = 0; P < F; P++) T[P] = k[P];
      }
    }
    return d;
  }, _paeth: f, _copyTile: w, _bin: A };
}();
(function() {
  const { _copyTile: A } = he, { _bin: R } = he, M = he._paeth;
  var h = { table: function() {
    const l = new Uint32Array(256);
    for (let s = 0; s < 256; s++) {
      let y = s;
      for (let U = 0; U < 8; U++) 1 & y ? y = 3988292384 ^ y >>> 1 : y >>>= 1;
      l[s] = y;
    }
    return l;
  }(), update(l, s, y, U) {
    for (let m = 0; m < U; m++) l = h.table[255 & (l ^ s[y + m])] ^ l >>> 8;
    return l;
  }, crc: (l, s, y) => 4294967295 ^ h.update(4294967295, l, s, y) };
  function e(l, s, y, U) {
    s[y] += l[0] * U >> 4, s[y + 1] += l[1] * U >> 4, s[y + 2] += l[2] * U >> 4, s[y + 3] += l[3] * U >> 4;
  }
  function t(l) {
    return Math.max(0, Math.min(255, l));
  }
  function u(l, s) {
    const y = l[0] - s[0], U = l[1] - s[1], m = l[2] - s[2], I = l[3] - s[3];
    return y * y + U * U + m * m + I * I;
  }
  function f(l, s, y, U, m, I, v) {
    v == null && (v = 1);
    const C = U.length, c = [];
    for (var o = 0; o < C; o++) {
      const S = U[o];
      c.push([S >>> 0 & 255, S >>> 8 & 255, S >>> 16 & 255, S >>> 24 & 255]);
    }
    for (o = 0; o < C; o++) {
      let S = 4294967295;
      for (var H = 0, E = 0; E < C; E++) {
        var L = u(c[o], c[E]);
        E != o && L < S && (S = L, H = E);
      }
    }
    const Q = new Uint32Array(m.buffer), z = new Int16Array(s * y * 4), B = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
    for (o = 0; o < B.length; o++) B[o] = 255 * ((B[o] + 0.5) / 16 - 0.5);
    for (let S = 0; S < y; S++) for (let D = 0; D < s; D++) {
      var N;
      o = 4 * (S * s + D), v != 2 ? N = [t(l[o] + z[o]), t(l[o + 1] + z[o + 1]), t(l[o + 2] + z[o + 2]), t(l[o + 3] + z[o + 3])] : (L = B[4 * (3 & S) + (3 & D)], N = [t(l[o] + L), t(l[o + 1] + L), t(l[o + 2] + L), t(l[o + 3] + L)]), H = 0;
      let K = 16777215;
      for (E = 0; E < C; E++) {
        const G = u(N, c[E]);
        G < K && (K = G, H = E);
      }
      const $ = c[H], W = [N[0] - $[0], N[1] - $[1], N[2] - $[2], N[3] - $[3]];
      v == 1 && (D != s - 1 && e(W, z, o + 4, 7), S != y - 1 && (D != 0 && e(W, z, o + 4 * s - 4, 3), e(W, z, o + 4 * s, 5), D != s - 1 && e(W, z, o + 4 * s + 4, 1))), I[o >> 2] = H, Q[o >> 2] = U[H];
    }
  }
  function g(l, s, y, U, m) {
    m == null && (m = {});
    const { crc: I } = h, v = R.writeUint, C = R.writeUshort, c = R.writeASCII;
    let o = 8;
    const H = l.frames.length > 1;
    let E, L = !1, Q = 33 + (H ? 20 : 0);
    if (m.sRGB != null && (Q += 13), m.pHYs != null && (Q += 21), m.iCCP != null && (E = pako.deflate(m.iCCP), Q += 21 + E.length + 4), l.ctype == 3) {
      for (var z = l.plte.length, B = 0; B < z; B++) l.plte[B] >>> 24 != 255 && (L = !0);
      Q += 8 + 3 * z + 4 + (L ? 8 + 1 * z + 4 : 0);
    }
    for (var N = 0; N < l.frames.length; N++)
      H && (Q += 38), Q += ($ = l.frames[N]).cimg.length + 12, N != 0 && (Q += 4);
    Q += 12;
    const S = new Uint8Array(Q), D = [137, 80, 78, 71, 13, 10, 26, 10];
    for (B = 0; B < 8; B++) S[B] = D[B];
    if (v(S, o, 13), o += 4, c(S, o, "IHDR"), o += 4, v(S, o, s), o += 4, v(S, o, y), o += 4, S[o] = l.depth, o++, S[o] = l.ctype, o++, S[o] = 0, o++, S[o] = 0, o++, S[o] = 0, o++, v(S, o, I(S, o - 17, 17)), o += 4, m.sRGB != null && (v(S, o, 1), o += 4, c(S, o, "sRGB"), o += 4, S[o] = m.sRGB, o++, v(S, o, I(S, o - 5, 5)), o += 4), m.iCCP != null) {
      const W = 13 + E.length;
      v(S, o, W), o += 4, c(S, o, "iCCP"), o += 4, c(S, o, "ICC profile"), o += 11, o += 2, S.set(E, o), o += E.length, v(S, o, I(S, o - (W + 4), W + 4)), o += 4;
    }
    if (m.pHYs != null && (v(S, o, 9), o += 4, c(S, o, "pHYs"), o += 4, v(S, o, m.pHYs[0]), o += 4, v(S, o, m.pHYs[1]), o += 4, S[o] = m.pHYs[2], o++, v(S, o, I(S, o - 13, 13)), o += 4), H && (v(S, o, 8), o += 4, c(S, o, "acTL"), o += 4, v(S, o, l.frames.length), o += 4, v(S, o, m.loop != null ? m.loop : 0), o += 4, v(S, o, I(S, o - 12, 12)), o += 4), l.ctype == 3) {
      for (v(S, o, 3 * (z = l.plte.length)), o += 4, c(S, o, "PLTE"), o += 4, B = 0; B < z; B++) {
        const W = 3 * B, G = l.plte[B], X = 255 & G, ee = G >>> 8 & 255, me = G >>> 16 & 255;
        S[o + W + 0] = X, S[o + W + 1] = ee, S[o + W + 2] = me;
      }
      if (o += 3 * z, v(S, o, I(S, o - 3 * z - 4, 3 * z + 4)), o += 4, L) {
        for (v(S, o, z), o += 4, c(S, o, "tRNS"), o += 4, B = 0; B < z; B++) S[o + B] = l.plte[B] >>> 24 & 255;
        o += z, v(S, o, I(S, o - z - 4, z + 4)), o += 4;
      }
    }
    let K = 0;
    for (N = 0; N < l.frames.length; N++) {
      var $ = l.frames[N];
      H && (v(S, o, 26), o += 4, c(S, o, "fcTL"), o += 4, v(S, o, K++), o += 4, v(S, o, $.rect.width), o += 4, v(S, o, $.rect.height), o += 4, v(S, o, $.rect.x), o += 4, v(S, o, $.rect.y), o += 4, C(S, o, U[N]), o += 2, C(S, o, 1e3), o += 2, S[o] = $.dispose, o++, S[o] = $.blend, o++, v(S, o, I(S, o - 30, 30)), o += 4);
      const W = $.cimg;
      v(S, o, (z = W.length) + (N == 0 ? 0 : 4)), o += 4;
      const G = o;
      c(S, o, N == 0 ? "IDAT" : "fdAT"), o += 4, N != 0 && (v(S, o, K++), o += 4), S.set(W, o), o += z, v(S, o, I(S, G, o - G)), o += 4;
    }
    return v(S, o, 0), o += 4, c(S, o, "IEND"), o += 4, v(S, o, I(S, o - 4, 4)), o += 4, S.buffer;
  }
  function w(l, s, y) {
    for (let U = 0; U < l.frames.length; U++) {
      const m = l.frames[U];
      m.rect.width;
      const I = m.rect.height, v = new Uint8Array(I * m.bpl + I);
      m.cimg = a(m.img, I, m.bpp, m.bpl, v, s, y);
    }
  }
  function r(l, s, y, U, m) {
    const I = m[0], v = m[1], C = m[2], c = m[3], o = m[4], H = m[5];
    let E = 6, L = 8, Q = 255;
    for (var z = 0; z < l.length; z++) {
      const ne = new Uint8Array(l[z]);
      for (var B = ne.length, N = 0; N < B; N += 4) Q &= ne[N + 3];
    }
    const S = Q != 255, D = function(Y, j, te, oe, V, se) {
      const J = [];
      for (var q = 0; q < Y.length; q++) {
        const ae = new Uint8Array(Y[q]), ue = new Uint32Array(ae.buffer);
        var le;
        let ce = 0, ve = 0, ge = j, Ue = te, ke = oe ? 1 : 0;
        if (q != 0) {
          const nt = se || oe || q == 1 || J[q - 2].dispose != 0 ? 1 : 2;
          let Ne = 0, De = 1e9;
          for (let Te = 0; Te < nt; Te++) {
            var ye = new Uint8Array(Y[q - 1 - Te]);
            const rt = new Uint32Array(Y[q - 1 - Te]);
            let be = j, Ae = te, _e = -1, Re = -1;
            for (let Ie = 0; Ie < te; Ie++) for (let Fe = 0; Fe < j; Fe++)
              ue[re = Ie * j + Fe] != rt[re] && (Fe < be && (be = Fe), Fe > _e && (_e = Fe), Ie < Ae && (Ae = Ie), Ie > Re && (Re = Ie));
            _e == -1 && (be = Ae = _e = Re = 0), V && ((1 & be) == 1 && be--, (1 & Ae) == 1 && Ae--);
            const We = (_e - be + 1) * (Re - Ae + 1);
            We < De && (De = We, Ne = Te, ce = be, ve = Ae, ge = _e - be + 1, Ue = Re - Ae + 1);
          }
          ye = new Uint8Array(Y[q - 1 - Ne]), Ne == 1 && (J[q - 1].dispose = 2), le = new Uint8Array(ge * Ue * 4), A(ye, j, te, le, ge, Ue, -ce, -ve, 0), ke = A(ae, j, te, le, ge, Ue, -ce, -ve, 3) ? 1 : 0, ke == 1 ? n(ae, j, te, le, { x: ce, y: ve, width: ge, height: Ue }) : A(ae, j, te, le, ge, Ue, -ce, -ve, 0);
        } else le = ae.slice(0);
        J.push({ rect: { x: ce, y: ve, width: ge, height: Ue }, img: le, blend: ke, dispose: 0 });
      }
      if (oe) for (q = 0; q < J.length; q++) {
        if ((we = J[q]).blend == 1) continue;
        const ae = we.rect, ue = J[q - 1].rect, ce = Math.min(ae.x, ue.x), ve = Math.min(ae.y, ue.y), ge = { x: ce, y: ve, width: Math.max(ae.x + ae.width, ue.x + ue.width) - ce, height: Math.max(ae.y + ae.height, ue.y + ue.height) - ve };
        J[q - 1].dispose = 1, q - 1 != 0 && i(Y, j, te, J, q - 1, ge, V), i(Y, j, te, J, q, ge, V);
      }
      let Me = 0;
      if (Y.length != 1) for (var re = 0; re < J.length; re++) {
        var we;
        Me += (we = J[re]).rect.width * we.rect.height;
      }
      return J;
    }(l, s, y, I, v, C), K = {}, $ = [], W = [];
    if (U != 0) {
      const ne = [];
      for (N = 0; N < D.length; N++) ne.push(D[N].img.buffer);
      const Y = function(V) {
        let se = 0;
        for (var J = 0; J < V.length; J++) se += V[J].byteLength;
        const q = new Uint8Array(se);
        let le = 0;
        for (J = 0; J < V.length; J++) {
          const ye = new Uint8Array(V[J]), Me = ye.length;
          for (let re = 0; re < Me; re += 4) {
            let we = ye[re], ae = ye[re + 1], ue = ye[re + 2];
            const ce = ye[re + 3];
            ce == 0 && (we = ae = ue = 0), q[le + re] = we, q[le + re + 1] = ae, q[le + re + 2] = ue, q[le + re + 3] = ce;
          }
          le += Me;
        }
        return q.buffer;
      }(ne), j = F(Y, U);
      for (N = 0; N < j.plte.length; N++) $.push(j.plte[N].est.rgba);
      let te = 0;
      for (N = 0; N < D.length; N++) {
        const oe = (X = D[N]).img.length;
        var G = new Uint8Array(j.inds.buffer, te >> 2, oe >> 2);
        W.push(G);
        const V = new Uint8Array(j.abuf, te, oe);
        H && f(X.img, X.rect.width, X.rect.height, $, V, G), X.img.set(V), te += oe;
      }
    } else for (z = 0; z < D.length; z++) {
      var X = D[z];
      const ne = new Uint32Array(X.img.buffer);
      var ee = X.rect.width;
      for (B = ne.length, G = new Uint8Array(B), W.push(G), N = 0; N < B; N++) {
        const Y = ne[N];
        if (N != 0 && Y == ne[N - 1]) G[N] = G[N - 1];
        else if (N > ee && Y == ne[N - ee]) G[N] = G[N - ee];
        else {
          let j = K[Y];
          if (j == null && (K[Y] = j = $.length, $.push(Y), $.length >= 300)) break;
          G[N] = j;
        }
      }
    }
    const me = $.length;
    for (me <= 256 && o == 0 && (L = me <= 2 ? 1 : me <= 4 ? 2 : me <= 16 ? 4 : 8, L = Math.max(L, c)), z = 0; z < D.length; z++) {
      (X = D[z]).rect.x, X.rect.y, ee = X.rect.width;
      const ne = X.rect.height;
      let Y = X.img;
      new Uint32Array(Y.buffer);
      let j = 4 * ee, te = 4;
      if (me <= 256 && o == 0) {
        j = Math.ceil(L * ee / 8);
        var de = new Uint8Array(j * ne);
        const oe = W[z];
        for (let V = 0; V < ne; V++) {
          N = V * j;
          const se = V * ee;
          if (L == 8) for (var Z = 0; Z < ee; Z++) de[N + Z] = oe[se + Z];
          else if (L == 4) for (Z = 0; Z < ee; Z++) de[N + (Z >> 1)] |= oe[se + Z] << 4 - 4 * (1 & Z);
          else if (L == 2) for (Z = 0; Z < ee; Z++) de[N + (Z >> 2)] |= oe[se + Z] << 6 - 2 * (3 & Z);
          else if (L == 1) for (Z = 0; Z < ee; Z++) de[N + (Z >> 3)] |= oe[se + Z] << 7 - 1 * (7 & Z);
        }
        Y = de, E = 3, te = 1;
      } else if (S == 0 && D.length == 1) {
        de = new Uint8Array(ee * ne * 3);
        const oe = ee * ne;
        for (N = 0; N < oe; N++) {
          const V = 3 * N, se = 4 * N;
          de[V] = Y[se], de[V + 1] = Y[se + 1], de[V + 2] = Y[se + 2];
        }
        Y = de, E = 2, te = 3, j = 3 * ee;
      }
      X.img = Y, X.bpl = j, X.bpp = te;
    }
    return { ctype: E, depth: L, plte: $, frames: D };
  }
  function i(l, s, y, U, m, I, v) {
    const C = Uint8Array, c = Uint32Array, o = new C(l[m - 1]), H = new c(l[m - 1]), E = m + 1 < l.length ? new C(l[m + 1]) : null, L = new C(l[m]), Q = new c(L.buffer);
    let z = s, B = y, N = -1, S = -1;
    for (let K = 0; K < I.height; K++) for (let $ = 0; $ < I.width; $++) {
      const W = I.x + $, G = I.y + K, X = G * s + W, ee = Q[X];
      ee == 0 || U[m - 1].dispose == 0 && H[X] == ee && (E == null || E[4 * X + 3] != 0) || (W < z && (z = W), W > N && (N = W), G < B && (B = G), G > S && (S = G));
    }
    N == -1 && (z = B = N = S = 0), v && ((1 & z) == 1 && z--, (1 & B) == 1 && B--), I = { x: z, y: B, width: N - z + 1, height: S - B + 1 };
    const D = U[m];
    D.rect = I, D.blend = 1, D.img = new Uint8Array(I.width * I.height * 4), U[m - 1].dispose == 0 ? (A(o, s, y, D.img, I.width, I.height, -I.x, -I.y, 0), n(L, s, y, D.img, I)) : A(L, s, y, D.img, I.width, I.height, -I.x, -I.y, 0);
  }
  function n(l, s, y, U, m) {
    A(l, s, y, U, m.width, m.height, -m.x, -m.y, 2);
  }
  function a(l, s, y, U, m, I, v) {
    const C = [];
    let c, o = [0, 1, 2, 3, 4];
    I != -1 ? o = [I] : (s * U > 5e5 || y == 1) && (o = [0]), v && (c = { level: 0 });
    const H = st;
    for (var E = 0; E < o.length; E++) {
      for (let z = 0; z < s; z++) d(m, l, z, U, y, o[E]);
      C.push(H.deflate(m, c));
    }
    let L, Q = 1e9;
    for (E = 0; E < C.length; E++) C[E].length < Q && (L = E, Q = C[E].length);
    return C[L];
  }
  function d(l, s, y, U, m, I) {
    const v = y * U;
    let C = v + y;
    if (l[C] = I, C++, I == 0) if (U < 500) for (var c = 0; c < U; c++) l[C + c] = s[v + c];
    else l.set(new Uint8Array(s.buffer, v, U), C);
    else if (I == 1) {
      for (c = 0; c < m; c++) l[C + c] = s[v + c];
      for (c = m; c < U; c++) l[C + c] = s[v + c] - s[v + c - m] + 256 & 255;
    } else if (y == 0) {
      for (c = 0; c < m; c++) l[C + c] = s[v + c];
      if (I == 2) for (c = m; c < U; c++) l[C + c] = s[v + c];
      if (I == 3) for (c = m; c < U; c++) l[C + c] = s[v + c] - (s[v + c - m] >> 1) + 256 & 255;
      if (I == 4) for (c = m; c < U; c++) l[C + c] = s[v + c] - M(s[v + c - m], 0, 0) + 256 & 255;
    } else {
      if (I == 2) for (c = 0; c < U; c++) l[C + c] = s[v + c] + 256 - s[v + c - U] & 255;
      if (I == 3) {
        for (c = 0; c < m; c++) l[C + c] = s[v + c] + 256 - (s[v + c - U] >> 1) & 255;
        for (c = m; c < U; c++) l[C + c] = s[v + c] + 256 - (s[v + c - U] + s[v + c - m] >> 1) & 255;
      }
      if (I == 4) {
        for (c = 0; c < m; c++) l[C + c] = s[v + c] + 256 - M(0, s[v + c - U], 0) & 255;
        for (c = m; c < U; c++) l[C + c] = s[v + c] + 256 - M(s[v + c - m], s[v + c - U], s[v + c - m - U]) & 255;
      }
    }
  }
  function F(l, s) {
    const y = new Uint8Array(l), U = y.slice(0), m = new Uint32Array(U.buffer), I = T(U, s), v = I[0], C = I[1], c = y.length, o = new Uint8Array(c >> 2);
    let H;
    if (y.length < 2e7) for (var E = 0; E < c; E += 4)
      H = b(v, L = y[E] * (1 / 255), Q = y[E + 1] * (1 / 255), z = y[E + 2] * (1 / 255), B = y[E + 3] * (1 / 255)), o[E >> 2] = H.ind, m[E >> 2] = H.est.rgba;
    else for (E = 0; E < c; E += 4) {
      var L = y[E] * 0.00392156862745098, Q = y[E + 1] * (1 / 255), z = y[E + 2] * (1 / 255), B = y[E + 3] * (1 / 255);
      for (H = v; H.left; ) H = k(H.est, L, Q, z, B) <= 0 ? H.left : H.right;
      o[E >> 2] = H.ind, m[E >> 2] = H.est.rgba;
    }
    return { abuf: U.buffer, inds: o, plte: C };
  }
  function T(l, s, y) {
    y == null && (y = 1e-4);
    const U = new Uint32Array(l.buffer), m = { i0: 0, i1: l.length, bst: null, est: null, tdst: 0, left: null, right: null };
    m.bst = O(l, m.i0, m.i1), m.est = p(m.bst);
    const I = [m];
    for (; I.length < s; ) {
      let C = 0, c = 0;
      for (var v = 0; v < I.length; v++) I[v].est.L > C && (C = I[v].est.L, c = v);
      if (C < y) break;
      const o = I[c], H = P(l, U, o.i0, o.i1, o.est.e, o.est.eMq255);
      if (o.i0 >= H || o.i1 <= H) {
        o.est.L = 0;
        continue;
      }
      const E = { i0: o.i0, i1: H, bst: null, est: null, tdst: 0, left: null, right: null };
      E.bst = O(l, E.i0, E.i1), E.est = p(E.bst);
      const L = { i0: H, i1: o.i1, bst: null, est: null, tdst: 0, left: null, right: null };
      for (L.bst = { R: [], m: [], N: o.bst.N - E.bst.N }, v = 0; v < 16; v++) L.bst.R[v] = o.bst.R[v] - E.bst.R[v];
      for (v = 0; v < 4; v++) L.bst.m[v] = o.bst.m[v] - E.bst.m[v];
      L.est = p(L.bst), o.left = E, o.right = L, I[c] = E, I.push(L);
    }
    for (I.sort((C, c) => c.bst.N - C.bst.N), v = 0; v < I.length; v++) I[v].ind = v;
    return [m, I];
  }
  function b(l, s, y, U, m) {
    if (l.left == null) return l.tdst = function(E, L, Q, z, B) {
      const N = L - E[0], S = Q - E[1], D = z - E[2], K = B - E[3];
      return N * N + S * S + D * D + K * K;
    }(l.est.q, s, y, U, m), l;
    const I = k(l.est, s, y, U, m);
    let v = l.left, C = l.right;
    I > 0 && (v = l.right, C = l.left);
    const c = b(v, s, y, U, m);
    if (c.tdst <= I * I) return c;
    const o = b(C, s, y, U, m);
    return o.tdst < c.tdst ? o : c;
  }
  function k(l, s, y, U, m) {
    const { e: I } = l;
    return I[0] * s + I[1] * y + I[2] * U + I[3] * m - l.eMq;
  }
  function P(l, s, y, U, m, I) {
    for (U -= 4; y < U; ) {
      for (; _(l, y, m) <= I; ) y += 4;
      for (; _(l, U, m) > I; ) U -= 4;
      if (y >= U) break;
      const v = s[y >> 2];
      s[y >> 2] = s[U >> 2], s[U >> 2] = v, y += 4, U -= 4;
    }
    for (; _(l, y, m) > I; ) y -= 4;
    return y + 4;
  }
  function _(l, s, y) {
    return l[s] * y[0] + l[s + 1] * y[1] + l[s + 2] * y[2] + l[s + 3] * y[3];
  }
  function O(l, s, y) {
    const U = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], m = [0, 0, 0, 0], I = y - s >> 2;
    for (let v = s; v < y; v += 4) {
      const C = l[v] * 0.00392156862745098, c = l[v + 1] * (1 / 255), o = l[v + 2] * (1 / 255), H = l[v + 3] * (1 / 255);
      m[0] += C, m[1] += c, m[2] += o, m[3] += H, U[0] += C * C, U[1] += C * c, U[2] += C * o, U[3] += C * H, U[5] += c * c, U[6] += c * o, U[7] += c * H, U[10] += o * o, U[11] += o * H, U[15] += H * H;
    }
    return U[4] = U[1], U[8] = U[2], U[9] = U[6], U[12] = U[3], U[13] = U[7], U[14] = U[11], { R: U, m, N: I };
  }
  function p(l) {
    const { R: s } = l, { m: y } = l, { N: U } = l, m = y[0], I = y[1], v = y[2], C = y[3], c = U == 0 ? 0 : 1 / U, o = [s[0] - m * m * c, s[1] - m * I * c, s[2] - m * v * c, s[3] - m * C * c, s[4] - I * m * c, s[5] - I * I * c, s[6] - I * v * c, s[7] - I * C * c, s[8] - v * m * c, s[9] - v * I * c, s[10] - v * v * c, s[11] - v * C * c, s[12] - C * m * c, s[13] - C * I * c, s[14] - C * v * c, s[15] - C * C * c], H = o, E = x;
    let L = [Math.random(), Math.random(), Math.random(), Math.random()], Q = 0, z = 0;
    if (U != 0) for (let N = 0; N < 16 && (L = E.multVec(H, L), z = Math.sqrt(E.dot(L, L)), L = E.sml(1 / z, L), !(N != 0 && Math.abs(z - Q) < 1e-9)); N++) Q = z;
    const B = [m * c, I * c, v * c, C * c];
    return { Cov: o, q: B, e: L, L: Q, eMq255: E.dot(E.sml(255, B), L), eMq: E.dot(L, B), rgba: (Math.round(255 * B[3]) << 24 | Math.round(255 * B[2]) << 16 | Math.round(255 * B[1]) << 8 | Math.round(255 * B[0]) << 0) >>> 0 };
  }
  var x = { multVec: (l, s) => [l[0] * s[0] + l[1] * s[1] + l[2] * s[2] + l[3] * s[3], l[4] * s[0] + l[5] * s[1] + l[6] * s[2] + l[7] * s[3], l[8] * s[0] + l[9] * s[1] + l[10] * s[2] + l[11] * s[3], l[12] * s[0] + l[13] * s[1] + l[14] * s[2] + l[15] * s[3]], dot: (l, s) => l[0] * s[0] + l[1] * s[1] + l[2] * s[2] + l[3] * s[3], sml: (l, s) => [l * s[0], l * s[1], l * s[2], l * s[3]] };
  he.encode = function(s, y, U, m, I, v, C) {
    m == null && (m = 0), C == null && (C = !1);
    const c = r(s, y, U, m, [!1, !1, !1, 0, C, !1]);
    return w(c, -1), g(c, y, U, I, v);
  }, he.encodeLL = function(s, y, U, m, I, v, C, c) {
    const o = { ctype: 0 + (m == 1 ? 0 : 2) + (I == 0 ? 0 : 4), depth: v, frames: [] }, H = (m + I) * v, E = H * y;
    for (let L = 0; L < s.length; L++) o.frames.push({ rect: { x: 0, y: 0, width: y, height: U }, img: new Uint8Array(s[L]), blend: 0, dispose: 1, bpp: Math.ceil(H / 8), bpl: Math.ceil(E / 8) });
    return w(o, 0, !0), g(o, y, U, C, c);
  }, he.encode.compress = r, he.encode.dither = f, he.quantize = F, he.quantize.getKDtree = T, he.quantize.getNearest = b;
})();
const je = { toArrayBuffer(A, R) {
  const M = A.width, h = A.height, e = M << 2, t = A.getContext("2d").getImageData(0, 0, M, h), u = new Uint32Array(t.data.buffer), f = (32 * M + 31) / 32 << 2, g = f * h, w = 122 + g, r = new ArrayBuffer(w), i = new DataView(r), n = 1 << 20;
  let a, d, F, T, b = n, k = 0, P = 0, _ = 0;
  function O(l) {
    i.setUint16(P, l, !0), P += 2;
  }
  function p(l) {
    i.setUint32(P, l, !0), P += 4;
  }
  function x(l) {
    P += l;
  }
  O(19778), p(w), x(4), p(122), p(108), p(M), p(-h >>> 0), O(1), O(32), p(3), p(g), p(2835), p(2835), x(8), p(16711680), p(65280), p(255), p(4278190080), p(1466527264), function l() {
    for (; k < h && b > 0; ) {
      for (T = 122 + k * f, a = 0; a < e; ) b--, d = u[_++], F = d >>> 24, i.setUint32(T + a, d << 8 | F), a += 4;
      k++;
    }
    _ < u.length ? (b = n, setTimeout(l, je._dly)) : R(r);
  }();
}, toBlob(A, R) {
  this.toArrayBuffer(A, (M) => {
    R(new Blob([M], { type: "image/bmp" }));
  });
}, _dly: 9 };
var fe = { CHROME: "CHROME", FIREFOX: "FIREFOX", DESKTOP_SAFARI: "DESKTOP_SAFARI", IE: "IE", IOS: "IOS", ETC: "ETC" }, lt = { [fe.CHROME]: 16384, [fe.FIREFOX]: 11180, [fe.DESKTOP_SAFARI]: 16384, [fe.IE]: 8192, [fe.IOS]: 4096, [fe.ETC]: 8192 };
const Be = typeof window < "u", qe = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, Pe = Be && window.cordova && window.cordova.require && window.cordova.require("cordova/modulemapper"), ct = (Be || qe) && (Pe && Pe.getOriginalSymbol(window, "File") || typeof File < "u" && File), Ke = (Be || qe) && (Pe && Pe.getOriginalSymbol(window, "FileReader") || typeof FileReader < "u" && FileReader);
function Qe(A, R, M = Date.now()) {
  return new Promise((h) => {
    const e = A.split(","), t = e[0].match(/:(.*?);/)[1], u = globalThis.atob(e[1]);
    let f = u.length;
    const g = new Uint8Array(f);
    for (; f--; ) g[f] = u.charCodeAt(f);
    const w = new Blob([g], { type: t });
    w.name = R, w.lastModified = M, h(w);
  });
}
function Ye(A) {
  return new Promise((R, M) => {
    const h = new Ke();
    h.onload = () => R(h.result), h.onerror = (e) => M(e), h.readAsDataURL(A);
  });
}
function Ze(A) {
  return new Promise((R, M) => {
    const h = new Image();
    h.onload = () => R(h), h.onerror = (e) => M(e), h.src = A;
  });
}
function Ee() {
  if (Ee.cachedResult !== void 0) return Ee.cachedResult;
  let A = fe.ETC;
  const { userAgent: R } = navigator;
  return /Chrom(e|ium)/i.test(R) ? A = fe.CHROME : /iP(ad|od|hone)/i.test(R) && /WebKit/i.test(R) ? A = fe.IOS : /Safari/i.test(R) ? A = fe.DESKTOP_SAFARI : /Firefox/i.test(R) ? A = fe.FIREFOX : (/MSIE/i.test(R) || document.documentMode) && (A = fe.IE), Ee.cachedResult = A, Ee.cachedResult;
}
function Xe(A, R) {
  const M = Ee(), h = lt[M];
  let e = A, t = R, u = e * t;
  const f = e > t ? t / e : e / t;
  for (; u > h * h; ) {
    const g = (h + e) / 2, w = (h + t) / 2;
    g < w ? (t = w, e = w * f) : (t = g * f, e = g), u = e * t;
  }
  return { width: e, height: t };
}
function Le(A, R) {
  let M, h;
  try {
    if (M = new OffscreenCanvas(A, R), h = M.getContext("2d"), h === null) throw new Error("getContext of OffscreenCanvas returns null");
  } catch {
    M = document.createElement("canvas"), h = M.getContext("2d");
  }
  return M.width = A, M.height = R, [M, h];
}
function Ve(A, R) {
  const { width: M, height: h } = Xe(A.width, A.height), [e, t] = Le(M, h);
  return R && /jpe?g/.test(R) && (t.fillStyle = "white", t.fillRect(0, 0, e.width, e.height)), t.drawImage(A, 0, 0, e.width, e.height), e;
}
function Se() {
  return Se.cachedResult !== void 0 || (Se.cachedResult = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || navigator.userAgent.includes("Mac") && typeof document < "u" && "ontouchend" in document), Se.cachedResult;
}
function He(A, R = {}) {
  return new Promise(function(M, h) {
    let e, t;
    var u = function() {
      try {
        return t = Ve(e, R.fileType || A.type), M([e, t]);
      } catch (g) {
        return h(g);
      }
    }, f = function(g) {
      try {
        var w = function(r) {
          try {
            throw r;
          } catch (i) {
            return h(i);
          }
        };
        try {
          let r;
          return Ye(A).then(function(i) {
            try {
              return r = i, Ze(r).then(function(n) {
                try {
                  return e = n, function() {
                    try {
                      return u();
                    } catch (a) {
                      return h(a);
                    }
                  }();
                } catch (a) {
                  return w(a);
                }
              }, w);
            } catch (n) {
              return w(n);
            }
          }, w);
        } catch (r) {
          w(r);
        }
      } catch (r) {
        return h(r);
      }
    };
    try {
      if (Se() || [fe.DESKTOP_SAFARI, fe.MOBILE_SAFARI].includes(Ee())) throw new Error("Skip createImageBitmap on IOS and Safari");
      return createImageBitmap(A).then(function(g) {
        try {
          return e = g, u();
        } catch {
          return f();
        }
      }, f);
    } catch {
      f();
    }
  });
}
function Oe(A, R, M, h, e = 1) {
  return new Promise(function(t, u) {
    let f;
    if (R === "image/png") {
      let w, r, i;
      return w = A.getContext("2d"), { data: r } = w.getImageData(0, 0, A.width, A.height), i = he.encode([r.buffer], A.width, A.height, 4096 * e), f = new Blob([i], { type: R }), f.name = M, f.lastModified = h, g.call(this);
    }
    {
      let w = function() {
        return g.call(this);
      };
      if (R === "image/bmp") return new Promise((r) => je.toBlob(A, r)).then((function(r) {
        try {
          return f = r, f.name = M, f.lastModified = h, w.call(this);
        } catch (i) {
          return u(i);
        }
      }).bind(this), u);
      {
        let r = function() {
          return w.call(this);
        };
        if (typeof OffscreenCanvas == "function" && A instanceof OffscreenCanvas) return A.convertToBlob({ type: R, quality: e }).then((function(i) {
          try {
            return f = i, f.name = M, f.lastModified = h, r.call(this);
          } catch (n) {
            return u(n);
          }
        }).bind(this), u);
        {
          let i;
          return i = A.toDataURL(R, e), Qe(i, M, h).then((function(n) {
            try {
              return f = n, r.call(this);
            } catch (a) {
              return u(a);
            }
          }).bind(this), u);
        }
      }
    }
    function g() {
      return t(f);
    }
  });
}
function pe(A) {
  A.width = 0, A.height = 0;
}
function Ce() {
  return new Promise(function(A, R) {
    let M, h, e, t;
    return Ce.cachedResult !== void 0 ? A(Ce.cachedResult) : Qe("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", "test.jpg", Date.now()).then(function(u) {
      try {
        return M = u, He(M).then(function(f) {
          try {
            return h = f[1], Oe(h, M.type, M.name, M.lastModified).then(function(g) {
              try {
                return e = g, pe(h), He(e).then(function(w) {
                  try {
                    return t = w[0], Ce.cachedResult = t.width === 1 && t.height === 2, A(Ce.cachedResult);
                  } catch (r) {
                    return R(r);
                  }
                }, R);
              } catch (w) {
                return R(w);
              }
            }, R);
          } catch (g) {
            return R(g);
          }
        }, R);
      } catch (f) {
        return R(f);
      }
    }, R);
  });
}
function Je(A) {
  return new Promise((R, M) => {
    const h = new Ke();
    h.onload = (e) => {
      const t = new DataView(e.target.result);
      if (t.getUint16(0, !1) != 65496) return R(-2);
      const u = t.byteLength;
      let f = 2;
      for (; f < u; ) {
        if (t.getUint16(f + 2, !1) <= 8) return R(-1);
        const g = t.getUint16(f, !1);
        if (f += 2, g == 65505) {
          if (t.getUint32(f += 2, !1) != 1165519206) return R(-1);
          const w = t.getUint16(f += 6, !1) == 18761;
          f += t.getUint32(f + 4, w);
          const r = t.getUint16(f, w);
          f += 2;
          for (let i = 0; i < r; i++) if (t.getUint16(f + 12 * i, w) == 274) return R(t.getUint16(f + 12 * i + 8, w));
        } else {
          if ((65280 & g) != 65280) break;
          f += t.getUint16(f, !1);
        }
      }
      return R(-1);
    }, h.onerror = (e) => M(e), h.readAsArrayBuffer(A);
  });
}
function et(A, R) {
  const { width: M } = A, { height: h } = A, { maxWidthOrHeight: e } = R;
  let t, u = A;
  return isFinite(e) && (M > e || h > e) && ([u, t] = Le(M, h), M > h ? (u.width = e, u.height = h / M * e) : (u.width = M / h * e, u.height = e), t.drawImage(A, 0, 0, u.width, u.height), pe(A)), u;
}
function tt(A, R) {
  const { width: M } = A, { height: h } = A, [e, t] = Le(M, h);
  switch (R > 4 && R < 9 ? (e.width = h, e.height = M) : (e.width = M, e.height = h), R) {
    case 2:
      t.transform(-1, 0, 0, 1, M, 0);
      break;
    case 3:
      t.transform(-1, 0, 0, -1, M, h);
      break;
    case 4:
      t.transform(1, 0, 0, -1, 0, h);
      break;
    case 5:
      t.transform(0, 1, 1, 0, 0, 0);
      break;
    case 6:
      t.transform(0, 1, -1, 0, h, 0);
      break;
    case 7:
      t.transform(0, -1, -1, 0, h, M);
      break;
    case 8:
      t.transform(0, -1, 1, 0, 0, M);
  }
  return t.drawImage(A, 0, 0, M, h), pe(A), e;
}
function $e(A, R, M = 0) {
  return new Promise(function(h, e) {
    let t, u, f, g, w, r, i, n, a, d, F, T, b, k, P, _, O, p, x, l;
    function s(U = 5) {
      if (R.signal && R.signal.aborted) throw R.signal.reason;
      t += U, R.onProgress(Math.min(t, 100));
    }
    function y(U) {
      if (R.signal && R.signal.aborted) throw R.signal.reason;
      t = Math.min(Math.max(U, t), 100), R.onProgress(t);
    }
    return t = M, u = R.maxIteration || 10, f = 1024 * R.maxSizeMB * 1024, s(), He(A, R).then((function(U) {
      try {
        return [, g] = U, s(), w = et(g, R), s(), new Promise(function(m, I) {
          var v;
          if (!(v = R.exifOrientation)) return Je(A).then((function(c) {
            try {
              return v = c, C.call(this);
            } catch (o) {
              return I(o);
            }
          }).bind(this), I);
          function C() {
            return m(v);
          }
          return C.call(this);
        }).then((function(m) {
          try {
            return r = m, s(), Ce().then((function(I) {
              try {
                return i = I ? w : tt(w, r), s(), n = R.initialQuality || 1, a = R.fileType || A.type, Oe(i, a, A.name, A.lastModified, n).then((function(v) {
                  try {
                    {
                      let c = function() {
                        if (u-- && (P > f || P > b)) {
                          let H, E;
                          return H = l ? 0.95 * x.width : x.width, E = l ? 0.95 * x.height : x.height, [O, p] = Le(H, E), p.drawImage(x, 0, 0, H, E), n *= a === "image/png" ? 0.85 : 0.95, Oe(O, a, A.name, A.lastModified, n).then(function(L) {
                            try {
                              return _ = L, pe(x), x = O, P = _.size, y(Math.min(99, Math.floor((k - P) / (k - f) * 100))), c;
                            } catch (Q) {
                              return e(Q);
                            }
                          }, e);
                        }
                        return [1];
                      }, o = function() {
                        return pe(x), pe(O), pe(w), pe(i), pe(g), y(100), h(_);
                      };
                      if (d = v, s(), F = d.size > f, T = d.size > A.size, !F && !T) return y(100), h(d);
                      var C;
                      return b = A.size, k = d.size, P = k, x = i, l = !R.alwaysKeepResolution && F, (C = (function(H) {
                        for (; H; ) {
                          if (H.then) return void H.then(C, e);
                          try {
                            if (H.pop) {
                              if (H.length) return H.pop() ? o.call(this) : H;
                              H = c;
                            } else H = H.call(this);
                          } catch (E) {
                            return e(E);
                          }
                        }
                      }).bind(this))(c);
                    }
                  } catch (c) {
                    return e(c);
                  }
                }).bind(this), e);
              } catch (v) {
                return e(v);
              }
            }).bind(this), e);
          } catch (I) {
            return e(I);
          }
        }).bind(this), e);
      } catch (m) {
        return e(m);
      }
    }).bind(this), e);
  });
}
const ut = `
let scriptImported = false
self.addEventListener('message', async (e) => {
  const { file, id, imageCompressionLibUrl, options } = e.data
  options.onProgress = (progress) => self.postMessage({ progress, id })
  try {
    if (!scriptImported) {
      // console.log('[worker] importScripts', imageCompressionLibUrl)
      self.importScripts(imageCompressionLibUrl)
      scriptImported = true
    }
    // console.log('[worker] self', self)
    const compressedFile = await imageCompression(file, options)
    self.postMessage({ file: compressedFile, id })
  } catch (e) {
    // console.error('[worker] error', e)
    self.postMessage({ error: e.message + '\\n' + e.stack, id })
  }
})
`;
let ze;
function ht(A, R) {
  return new Promise((M, h) => {
    ze || (ze = function(u) {
      const f = [];
      return f.push(u), URL.createObjectURL(new Blob(f));
    }(ut));
    const e = new Worker(ze);
    e.addEventListener("message", function(u) {
      if (R.signal && R.signal.aborted) e.terminate();
      else if (u.data.progress === void 0) {
        if (u.data.error) return h(new Error(u.data.error)), void e.terminate();
        M(u.data.file), e.terminate();
      } else R.onProgress(u.data.progress);
    }), e.addEventListener("error", h), R.signal && R.signal.addEventListener("abort", () => {
      h(R.signal.reason), e.terminate();
    }), e.postMessage({ file: A, imageCompressionLibUrl: R.libURL, options: { ...R, onProgress: void 0, signal: void 0 } });
  });
}
function ie(A, R) {
  return new Promise(function(M, h) {
    let e, t, u, f, g, w;
    if (e = { ...R }, u = 0, { onProgress: f } = e, e.maxSizeMB = e.maxSizeMB || Number.POSITIVE_INFINITY, g = typeof e.useWebWorker != "boolean" || e.useWebWorker, delete e.useWebWorker, e.onProgress = (a) => {
      u = a, typeof f == "function" && f(u);
    }, !(A instanceof Blob || A instanceof ct)) return h(new Error("The file given is not an instance of Blob or File"));
    if (!/^image/.test(A.type)) return h(new Error("The file given is not an image"));
    if (w = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, !g || typeof Worker != "function" || w) return $e(A, e).then((function(a) {
      try {
        return t = a, n.call(this);
      } catch (d) {
        return h(d);
      }
    }).bind(this), h);
    var r = (function() {
      try {
        return n.call(this);
      } catch (a) {
        return h(a);
      }
    }).bind(this), i = function(a) {
      try {
        return $e(A, e).then(function(d) {
          try {
            return t = d, r();
          } catch (F) {
            return h(F);
          }
        }, h);
      } catch (d) {
        return h(d);
      }
    };
    try {
      return e.libURL = e.libURL || "https://cdn.jsdelivr.net/npm/browser-image-compression@2.0.2/dist/browser-image-compression.js", ht(A, e).then(function(a) {
        try {
          return t = a, r();
        } catch {
          return i();
        }
      }, i);
    } catch {
      i();
    }
    function n() {
      try {
        t.name = A.name, t.lastModified = A.lastModified;
      } catch {
      }
      try {
        e.preserveExif && A.type === "image/jpeg" && (!e.fileType || e.fileType && e.fileType === A.type) && (t = Ge(A, t));
      } catch {
      }
      return M(t);
    }
  });
}
ie.getDataUrlFromFile = Ye, ie.getFilefromDataUrl = Qe, ie.loadImage = Ze, ie.drawImageInCanvas = Ve, ie.drawFileInCanvas = He, ie.canvasToFile = Oe, ie.getExifOrientation = Je, ie.handleMaxWidthOrHeight = et, ie.followExifOrientation = tt, ie.cleanupCanvasMemory = pe, ie.isAutoOrientationInBrowser = Ce, ie.approximateBelowMaximumCanvasSizeOfBrowser = Xe, ie.copyExifWithoutOrientation = Ge, ie.getBrowserName = Ee, ie.version = "2.0.2";
const pt = (A, R, M, h, e, t, u) => {
  var T, b, k, P;
  const f = ((T = h == null ? void 0 : h.find((_) => _.value === A.cardHolderRelationType)) == null ? void 0 : T.value) || "", g = (b = M == null ? void 0 : M.addresses) == null ? void 0 : b.find((_) => _.addressType === "PRIMARY"), w = {
    address: {
      addressLine1: (g == null ? void 0 : g.addressLine1) || "",
      city: (g == null ? void 0 : g.city) || "",
      state: (g == null ? void 0 : g.state) || "",
      zip: (g == null ? void 0 : g.zip) || "",
      country: (g == null ? void 0 : g.country) || "",
      addressType: "PRIMARY"
    },
    firstName: (M == null ? void 0 : M.user.firstName) || "",
    lastName: (M == null ? void 0 : M.user.lastName) || "",
    email: ((P = (k = M == null ? void 0 : M.contacts) == null ? void 0 : k.find((_) => _.contactType === "EMAIL")) == null ? void 0 : P.contactInfo) || "",
    createdTs: (/* @__PURE__ */ new Date()).toISOString(),
    dateOfBirth: (M == null ? void 0 : M.user.dob) || "",
    username: (M == null ? void 0 : M.user.username) || "",
    createdBy: t ?? "",
    relationType: "SELF",
    myHealthOneId: (M == null ? void 0 : M.user.myHealthOneId) || ""
  }, r = u && (e == null ? void 0 : e.find((_) => {
    var O, p;
    return ((O = _.id) == null ? void 0 : O.toString()) === ((p = A.relationshipId) == null ? void 0 : p.toString());
  })) || null, i = A.relationship, n = r ? { ...r, relationType: i } : null;
  let a;
  A.isCardholder !== "true" ? u ? a = n : a = e == null ? void 0 : e.find((_) => {
    var O;
    return ((O = _.id) == null ? void 0 : O.toString()) === A.relationship;
  }) : a = w;
  const d = a || {
    createdTs: (/* @__PURE__ */ new Date()).toISOString(),
    firstName: A.cardHolderFirstName || "",
    lastName: A.cardHolderLastName || "",
    phone: A.cardHolderPhone || "",
    phoneType: A.cardHolderPhoneType || "",
    relationType: f || "",
    dateOfBirth: (A == null ? void 0 : A.cardHolderDateOfBirth) ?? "",
    email: "",
    username: "",
    createdBy: t ?? "",
    address: {
      addressLine1: "",
      addressLine2: "",
      addressType: "PRIMARY",
      city: "",
      state: "",
      zip: "",
      country: ""
    }
  };
  return {
    id: R ?? 0,
    cardBackImageId: A.backImage ?? "",
    cardFrontImageId: A.frontImage ?? "",
    cardHolder: A.isCardholder === "true",
    primary: A.primary,
    guarantorUserRelationship: d,
    insuranceName: A.insuranceName ?? "",
    insuranceGroup: A.insuranceGroup ?? "",
    insuranceNumber: A.insuranceId ?? "",
    insurancePhoneNumber: A.insurancePhone ?? "",
    insuranceAddress: {
      addressLine1: A.address1 ?? "",
      addressLine2: A.address2 ?? "",
      city: A.city ?? "",
      state: A.state ?? "",
      zip: A.zip ?? "",
      country: ""
    }
  };
}, vt = (A) => {
  const R = new FormData();
  return R.append("file", A.file), R.append("imageId", ""), R.append("imageType", A.imageType), R;
}, yt = (A) => {
  var h, e;
  const R = [A.insuranceName], M = [];
  if (A.insuranceNumber && R.push(`ID: ${A.insuranceNumber}`), A.insuranceGroup && R.push(`Group: ${A.insuranceGroup}`), A.insurancePhoneNumber && R.push(A.insurancePhoneNumber), (h = A.insuranceAddress) != null && h.addressLine1 && (R.push(`
              ${A.insuranceAddress.addressLine1}${A.insuranceAddress.addressLine1 ? `, ${A.insuranceAddress.addressLine2}` : ""}
              `), R.push(
    `${A.insuranceAddress.city}, ${A.insuranceAddress.state} ${A.insuranceAddress.zip}`
  )), A.guarantorUserRelationship && M.push(
    `${A.guarantorUserRelationship.firstName} ${A.guarantorUserRelationship.lastName}`
  ), (e = A == null ? void 0 : A.guarantorUserRelationship) != null && e.relationType) {
    const t = dt(A.guarantorUserRelationship.relationType);
    M.push(t);
  }
  return {
    content: R,
    cardHolder: M
  };
}, dt = (A) => A && A ? A.toLowerCase().split("_").map((R) => R.charAt(0).toUpperCase() + R.slice(1)).join(" ") : "", bt = async (A, R, M, h) => {
  h(!0);
  try {
    const e = await ie(A, {
      ...R,
      fileType: R.fileType || A.type
    });
    M(e);
  } catch (e) {
    console.error("Error during image compression:", e), M(A);
  } finally {
    h(!1);
  }
}, At = (A) => Object.values(it).includes(A);
export {
  dt as f,
  At as i,
  yt as m,
  vt as p,
  bt as s,
  pt as u
};
